// This file is automatically generated.
// Do not edit this file manually, use the script createLocales.js!

/* eslint-disable quotes */
/* eslint-disable indent */

export default {
  "__vendor__": "mtf",
  "devise": {
    "failure": {
      "bad_request": "Des données eronnées ont été transférées. Veuillez réessayer.",
      "already_registered": "Cette adresse e-mail est déjà enregistrée. Un e-mail d'activation a été envoyé à votre adresse e-mail. Veuillez vérifier votre boîte de récéption e-mail et activer votre compte.",
      "timeout": "Votre session est périmée, veuillez vous reconnecter pour continuer.",
      "forbidden": "Interdit",
      "invalid": "E-mail ou mot de passe incorrect.",
      "username": {
        "already_in_use": "Ce nom d'utilisateur est déjà utilisé !"
      },
      "email": {
        "already_in_use": "Cette adresse e-mail est déjà utilisée !"
      },
      "already_activated": "Si votre e-mail existe sur notre base de données, vous recevrez sous quelques minutes un message avec des instructions pour récupérer votre mot de passe."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Instructions de confirmation"
      },
      "reset_password_instructions": {
        "subject": "Instructions pour changer le mot de passe"
      }
    },
    "confirmations": {
      "send_instructions": "Vous allez recevoir sous quelques minutes un e-mail comportant des instructions pour confirmer votre compte.",
      "send_instructions_paranoid": "Si vous avez créé un compte VBus.net, vous recevrez un e-mail dans quelques minutes pour valider votre inscription. Veuillez vérifier votre boîte de réception e-mail. "
    },
    "passwords": {
      "updated_not_active": "Votre mot de passe a été modifié avec succès.",
      "send_paranoid_instructions": "Si votre e-mail existe dans notre base de données, vous recevrez un lien vous permettant de récupérer votre mot de passe."
    },
    "registrations": {
      "destroyed": "Au revoir ! Votre compte a été annulé avec succès. Nous espérons vous revoir bientôt."
    }
  },
  "general": {
    "welcome": "Bienvenue",
    "yourProAccount": "Votre accès VBus.net PRO",
    "hello": "Bonjour",
    "greetings": "Meilleures salutations",
    "vbusnetTeam": "Votre équipe VBus.net",
    "errorInvalidCharacters": "Caractères invalides",
    "emailUnsubscribed": "Votre adresse e-mail a été supprimée avec succès.",
    "emailAlreadyUnsubscribed": "Votre adresse e-mail a déjà été supprimée.",
    "newDevice": "Nouvel appareil",
    "isFriend": "Partager",
    "backup": {
      "error": {
        "file": "Fichier de sauvegarde erroné ou endommagé !",
        "fileMatchSystem": "Fichier de sauvegarde ne correspond pas au système sélectionné."
      },
      "choose": {
        "file": "Sélectionner fichier de sauvegarde…"
      },
      "restore": "Restaurer sauvegarde",
      "successful": "Vos données ont été restaurées avec succès.",
      "name": "Sauvegarde",
      "create": "Créer une sauvegarde",
      "text1": "Ici, vous trouverez une vue d'ensemble de vos données. Sélectionnez les points que vous souhaitez sauvegarder. Si vous sélectionnez un système en direct, un diagramme ou un téléchargement, les filtres et images correspondants seront également sauvegardés.",
      "file": "Fichier de sauvegarde",
      "text2": "Toutes les données de la sauvegarde sont listées ci-dessous. Vous pouvez restaurer toutes les données ou des données sélectionnées. Si vous choisissez un système en direct, un diagramme ou un téléchargement, les filtres et images correspondants seront également restaurés.",
      "fileType": "Le fichier doit être un fichier de sauvegarde VBus.net valide !",
      "text3": "Vos données en direct ont été modifiées depuis la sauvegarde ! Cela arrive lorsque de nouveaux appareils sont connectés ou que des appareils déjà connectés sont enlevés et connectés de nouveau. Veuillez noter que l'attribution des filtres pourrait être incorrecte après une restauration.",
      "visualization": "Sauvegarde données de visualisation"
    },
    "days": "Jours",
    "entryNotFound": "Aucune entrée trouvée.",
    "allValues": "Toutes les valeurs",
    "unknown": "Inconnu",
    "from": "De",
    "to": "Jusqu'à",
    "customRange": "Période définie librement ",
    "name": "Nom",
    "unit": "Unité",
    "color": "Couleur",
    "format": "Format",
    "errorTryAgain": "Une erreur s'est produite. Veuillez réessayer plus tard…",
    "interestedInProducts": "Merci de votre intérêt pour nos produits.",
    "ok": "OK",
    "currentAccount": "Accès actuel",
    "newInvalidDate": "Nouvelle date d'expiration",
    "KontaktformularKenntnis": "J'ai pris connaissance de la __PRIVACY_POLICY__. J'accepte la collecte et le stockage de mes informations et données pour répondre à ma demande.",
    "interval": "Intervalle",
    "minute": "Minute",
    "minutes": "minutes",
    "monday": "Lundi",
    "tuesday": "Mardi ",
    "wednesday": "Mercredi",
    "thursday": "Jeudi",
    "friday": "Vendredi",
    "saturday": "Samedi",
    "sunday": "Dimanche",
    "displayValue": "Valeur d'affichage",
    "conversions": "Conversions",
    "add": "ajouter",
    "displayUnit": "Unité d'affichage",
    "none": "Aucune",
    "close": "Fermer",
    "apply": "Utiliser",
    "note": "Indication",
    "deleteIrrevocably": "Les données seront définitivement supprimées !",
    "delete": "Supprimer",
    "errors": "Erreurs",
    "noErrors": "Pas d'erreurs",
    "error": "Erreur",
    "deleted": "Supprimée !",
    "entryDeleted": "La saisie a été supprimée.",
    "save": "Enregistrer",
    "edit": "Modifier",
    "status": "État",
    "cancel": "Annuler",
    "weiter": "Continuer",
    "yesDelete": "Oui, supprimer.",
    "no": "Non",
    "configurationDeleted": "La configuration a été supprimée.",
    "selectAll": "Sélectionner tous",
    "unselectAll": "Déselectionner tous",
    "download": "Téléchargement",
    "prefix": "Préfixe",
    "subscription": "Accès",
    "information": "Information",
    "passwordCurrent": "Mot de passe actuel",
    "languageForEmail": "Langue (e-mails)",
    "defaultUnits": "Unités standards",
    "dateFormat": "Format de date",
    "myPersonalSettings": "Mes données personnelles",
    "changeYourPassword": "Changer le mot de passe",
    "login": "Se connecter",
    "newPassword": "Nouveau mot de passe",
    "passwordLength": "doit avoir au moins 6 caractères",
    "passwordConfirmNewPassword": "Validez le nouveau mot de passe",
    "forgotYourPassword": "Mot de passe oublié ?",
    "passwordDifferent": "Les deux mots de passe ne sont pas identiques.",
    "password": "Mot de passe",
    "nameResolRegler": "Régulateur RESOL",
    "pleaseChoose": "Veuillez choisir",
    "invalidCharacters": "Caractères invalides",
    "chooseLanguage": "Sélectionner la langue",
    "langGerman": "Allemand",
    "langEnglish": "Anglais",
    "langFrench": "Français",
    "langItalian": "Italien",
    "langSpanish": "Espagnol",
    "langSuomi": "Finnois",
    "showDiagram": "Afficher diagramme",
    "diagramTitle": "Titre du diagramme",
    "publicLink": "Lien public",
    "loadingData": "Chargement de données en cours, veuillez patienter",
    "saving": "Enregistrement en cours",
    "yourLiveData": "Vos données en direct",
    "warningNoLivedata": "Pas de données en direct disponibles !",
    "noResults": "Votre sélection ne donne aucun résultat !",
    "removeAll": "Supprimer tous",
    "undo": "Annuler",
    "originalNamesValues": "Nom et valeurs d'origine",
    "conversionAvailable": "Conversion disponible",
    "maxAllowedFilterValues": "Le filtre dispose de plus de valeurs que permis ! Un Datalogger de démonstration ne peut contenir que 10 valeurs de filtre au maximum. Lors de la sauvegarde, seules les premières 10 valeurs de filtre seront sauvegardées.",
    "filterDeleted": "Le filtre a été supprimé.",
    "showCustomImages": "Propres images",
    "imageDeleted": "L'image a été supprimée.",
    "system": "Système",
    "autoscaleDescription": "Redimensionner le système en direct à la résolution maximale de l'écran.",
    "lastSent": "Envoyée en dernier",
    "on": "le",
    "language": "Langue",
    "active": "actif",
    "inactive": "inactif",
    "daily": "Journalier",
    "weekly": "Hebdomadaire",
    "monthly": "Mensuel",
    "settings": "Configuration générale",
    "online": "Connecté",
    "offline": "Déconnecté",
    "confirmed": "validé",
    "notConfirmed": "non validé",
    "demo": "Démonstration",
    "accessDatalogger": "L'accès VBus.net se trouve dans l'interace Web de votre Datalogger !",
    "loginDatalogger": "Veuillez vous connecter à l'interface Web de votre Datalogger et activer l'accès sous :",
    "settingsDatalogger": "Configuration / Accès à distance / Accès à distance à travers Internet",
    "timezone": "Fuseau horaire",
    "location": "Emplacement",
    "geodata": "Coordonnées géographiques",
    "search": "Rechercher",
    "change": "Modifier",
    "advancedSettings": "Configuration avancée",
    "visuaEnablingVbusnet": "VBus.net se connecte régulièrement à votre Datalogger ou module de communication pour charger des données actuelles. Ceci utilise le volume de données et le taux de transfert de votre accès Internet. Si vous ne le souhaitez pas, vous pouvez désactiver le trafic de données ici. Veuillez noter que VBus.net n'obtiendra plus de nouvelles données et que les données historiques ne seront pas synchronisées par VBus.net ultérieurement.",
    "userComments": "Commentaires de l'utilisateur",
    "adminComments": "Commentaires de l'admin",
    "accessToken": "Code d'accès (token)",
    "claimDevice": "Ajouter un appareil",
    "yes": "Oui",
    "firmware": "Logiciel résident",
    "serial": "Numéro de série",
    "enabled": "Autorisé",
    "disabled": "Non autorisé",
    "userComment": "Commentaire de l'utilisateur",
    "defaultSettings": "Réglages de base",
    "controller": "Régulateur",
    "interface": "Interface",
    "technicalData": "Caractéristiques techniques",
    "privatePerson": "Personne privée",
    "topic": "Sujet",
    "yourName": "Votre nom",
    "addNoticeSing": "Indication supplémentaire",
    "sendAdditionalInformation": "Send additional information for easier support",
    "Einwilligung": "Consentement relatif à la protection des données",
    "KontaktformularHinweis": "Vous pouvez annuler à tout moment l'autorisation pour l'avenir en envoyant un e-mail à datenschutz@dvm-cloud.net",
    "send": "Envoyer",
    "feedbackText": "General feedback",
    "improvement": {
      "proposal": "Improvement proposal"
    },
    "nameTechnicalSupport": "Assistance technique",
    "question": "Question",
    "hervorragend": "excellent",
    "gut": "good",
    "neutral": "neutral",
    "ausreichend": "sufficient",
    "unzureichend": "insufficient",
    "kinderleicht": "very easy",
    "intuitiv": "intuitive",
    "kompliziert": "complicated",
    "nichtbedienbar": "not operable",
    "unverzichtbar": "indispensable",
    "sehrhilfreich": "very useful",
    "teilweisenuetzlich": "partly useful",
    "unbrauchbar": "useless",
    "sendResetPasswordInstructions": "Envoyez-moi des instructions pour changer mon mot de passe",
    "nameTechnicalSupportTime": "Du Lundi au Vendredi de 08h00 à 16h30",
    "feedbackName": "Feedback",
    "feedback": "Formulaire feedback",
    "ImpressumAngaben": "Informations conformes au § 5 de la loi allemande sur les télémédias (TMG).",
    "Streitschlichtung": "Conciliation ",
    "StreitschlichtungText": "Nous ne sommes ni prêts ni obligés à participer à une procédure de conciliation devant un bureau de conciliation des consommateurs.",
    "StreitschlichtungAllgemein": "Bureau général de conciliation des consommateurs : ",
    "nameDataloggerKomm": "Datalogger DL2/DL3 ou module de communication KM2",
    "nameRouter": "Routeur",
    "Versionsvergleich": "BASIC contre PRO",
    "year": "Année",
    "passwordConfirmation": "Valider le mot de passe",
    "Pflichtfelder": "Les champs marqués d'un * doivent être remplis.",
    "resendConfirmationInstuctions": "Me renvoyer le mail de confirmation",
    "back": "Retour",
    "years": "Années",
    "basicLiveSystemText": "L’éditeur de systèmes en direct vous permet d’afficher vos données en direct sur une image de système. Vous pouvez placer les données sur le schéma en les faisant glisser à l’endroit voulu sur l’image et ajouter des symboles tels que des réservoirs ou des vannes. Les données seront actualisées toutes les 5 minutes, sans avoir à recharger la page.",
    "basicConnectionText": "VBus.net vous permet d’accéder aux données de votre système de manière simple et sécurisée, sans installation de logiciel ou connaissances du réseau. ",
    "freeBasicFunctions": "Fonctions de base gratuites",
    "basicLiveDataText": "Les données en direct de votre système peuvent être affichées sous forme d’un tableau clair – cela vous permet de voir, en un coup d’œil, les valeurs de mesure actuelles.",
    "basicDiagrammeText": "Les données enregistrées peuvent être affichées sous forme de diagramme paramétrable. ",
    "GeplanteDownloadsText": "Recevez régulièrement et automatiquement par e-mail les données enregistrées de votre système. Vous pouvez définir la périodicité et définir les destinataires.",
    "ReporteText": "Recevez par e-mail des rapports configurables sur l’état de votre système solaire.",
    "GeraetTeilenText": "Partagez votre appareil avec d’autres utilisateurs VBus.net  ̶  par exemple avec votre installateur ou conseiller en énergie à titre d’information ou pour la maintenance.",
    "SystemEditorText": "Utilisez les nombreuses fonctionnalités proposées par l’éditeur avancé pour créer votre propre système en direct et ajouter des images de composants ou de schémas d’installation.",
    "SicherungText": "Vous pouvez sauvegarder ou restaurer tous vos réglages de visualisation en seulement quelques clics.",
    "FehlerprotokollText": "Cette fonction permet de visualiser les erreurs survenues dans votre système et de détecter rapidement et simplement une panne.",
    "BenachrichtigungenText": "Avec cette fonction vous pouvez choisir le contenu et les destinataires des notifications, par exemple en cas d’erreurs.",
    "ParametrisierenText1": "Paramétrez très simplement votre régulateur à distance à travers votre navigateur Internet. Sauvegardez les configurations directement dans VBus.net et transférez-les sur votre régulateur, si nécessaire.",
    "basicText1": "Testez VBus.net – la version de base est gratuite et un Datalogger de démonstration sera disponible immédiatement après l’inscription. Affichez les données dans un système en direct ou créez des diagrammes à partir des données enregistrées.",
    "basicConnection": "Accès sécurisé à votre système",
    "basicLiveSystem": "Systèmes en direct",
    "basicLiveData": "Afficher les données en direct",
    "basicDiagramme": "Diagrammes",
    "proFunctions": "Fonctions PRO en un coup d‘oeil",
    "logout": "Se déconnecter",
    "Funktionsbeschreibung": "Description des fonctions",
    "kommunikationsmodulKM2": "Module de communication KM2",
    "dataloggerDL2": "Datalogger DL2",
    "dataloggerDL3": "Datalogger DL3",
    "Informations": "Informations",
    "tools": "Outils",
    "rechtliches": "Informations Légales",
    "products": "Produits",
    "preferences": "Configuration",
    "menutype": "Navigation rapide",
    "Visualisieren": "Visualisation",
    "Ueberwachen": "Surveillance",
    "vbusnetRequirements": "Conditions requises pour l’utilisation de VBus.net",
    "vbusnetRequirementsText": "Pour pouvoir utiliser VBus.net, votre régulateur RESOL doté d’une interface de données VBus® doit être connecté à Internet à travers un Datalogger (DL2/DL3) ou un module de communication (KM2). L’installation d’un logiciel n’est pas requise.",
    "VisualisierenText1": "Les possibilités de visualisation offertes par VBus.net vous permettent de voir, en un coup d’œil, les données de votre système.",
    "VisualisierenText2": "Affichez les données de votre système sous forme d’un graphique claire ou créez des diagrammes pour afficher les données du jour, de la semaine ou du mois.",
    "UeberwachenText1": "Surveillez votre système simplement à travers des rapports et notifications automatiques. ",
    "UeberwachenText2": "Recevez régulièrement par e-mail des informations sur l'état de votre système solaire. Restez informé pour réagir immédiatement en cas de problème. Identifiez les dysfonctionnements au plus tôt – recevez des rapports et envoyez-les à votre installateur pour analyse.",
    "ParametrisierenText2": "Compatible avec les régulateurs solaires et de systèmes suivants : ",
    "proAccountRequired": "Un accès PRO est requis !",
    "inviteFriend": "Partager appareil",
    "Parametrisieren": "Paramétrage",
    "indexPortal": "Le portail pour votre système solaire et de chauffage",
    "schnittstellenadapter": "L‘adaptateur VBus®/LAN n’est pas compatible avec VBus.net !",
    "km2": {
      "title": "Solution économique pour l'accès à distance au régulateur",
      "text": "Le module de communication KM2 est l’interface idéale entre un régulateur solaire ou de chauffage et le réseau Internet. La connexion entre le régulateur RESOL et le portail de visualisation VBus.net s’effectue en quelques étapes. Le module de communication est conçu pour tous les régulateurs équipés du RESOL  VBus® et permet l’accès simple et sécurisé aux données du système à travers VBus.net. L’accès à distance à votre régulateur RESOL est également possible à travers le logiciel de paramétrage RPT."
    },
    "dl2": {
      "title": "Datalogger DL2 – Accès à distance au régulateur et enregistrement de données intégré",
      "text": "Le Datalogger DL2 est l‘interface entre un régulateur RESOL et le réseau Internet et sert de plus à enregistrer les données du système. Le DL2 permet d‘accéder à ces données à travers www.VBus.net."
    },
    "dl3": {
      "title": "Datalogger DL3 – Enregistrement de données avec gamme de fonctions élargie",
      "text": "Le Datalogger DL3 sert à enregistrer les données de jusqu’à 6 régulateurs RESOL et permet la visualisation à travers www.VBus.net ainsi que le paramétrage à travers RPT. Son grand écran graphique donne un aperçu des régulateurs connectés, tous les réglages importants peuvent s’effectuer directement sur le DL3. Les entrées sondes et impulsions intégrées peuvent mesurer et enregistrer des températures – même sans régulateur. Le DL3 dispose de plus d’une fonctionnalité BACnet pour communication des données en protocole BACnet permettant une intégration aisée dans un système de gestion technique du bâtiment."
    },
    "profitPro": "Profitez de toutes les fonctions VBus.net et commandez votre accès PRO. ",
    "Funktionsvergleich": "Comparaison de fonctions",
    "danke": "RESOL vous remercie",
    "team": "Votre équipe RESOL",
    "errorRequired": "__Feld__ est obligatoire!",
    "errorInvalid": "__Feld__est erroné !",
    "errorNotEqual": "__Feld__ est incorrect !",
    "collapse": {
      "all": "Replier tout"
    },
    "expand": {
      "all": "Déplier tout"
    },
    "help": "Aide",
    "loading": "Chargement en cours",
    "data": "Données",
    "notice": "Indication",
    "quickDiagram": "Diagramme rapide",
    "quickDownload": "Téléchargement rapide",
    "saved": "Enregistré",
    "unknow": "Inconnu",
    "warning": "Attention",
    "upload": "Charger",
    "uploadCustomImage": "Charger sa propre image",
    "version": "Version",
    "device": "Appareil",
    "own": {
      "name": "Nom personnalisé"
    },
    "getFullVersion": "Version complète",
    "limitations": "Limites d'utilisation",
    "filter": "Obligatoire",
    "addNote": "Indications supplémentaires",
    "contactAdr": "Adresse personelle",
    "loggedInAs": {
      "prefix": "Connecté en tant que",
      "suffix": "C'est pas vous ?"
    },
    "actions": "Actions",
    "tip": "Conseil",
    "info": "Information",
    "link": "Lien",
    "register": "Créer un compte",
    "or": "ou",
    "and": "et",
    "rememberMe": "Rester connecté",
    "changeMyPassword": "Changer mon mot de passe",
    "wrongEmailOrPassword": "E-mail ou mot de passe erroné",
    "newOwnership": "Nouvel appareil",
    "alert": "Attention",
    "update": "Mise à jour",
    "comments": "Commentaires",
    "videos": "Videos",
    "downloads": "Downloads",
    "dokumente": "Documents",
    "datenblatt": "Fiche technique",
    "montageanleitung": "Notice de montage",
    "filtern": "filtrer",
    "type": "Type",
    "until": "à",
    "datapoint": "Donnée",
    "seconds": "secondes",
    "hours": "hours",
    "position": "Position",
    "move": "déplacer",
    "billingAdr": "Adresse de facturation",
    "billingAdrAdd": "(si celle-ci est différente de l'adresse personnelle)",
    "terminateFriend": "Supprimer l'accès à cet appareil",
    "myFriends": "Mes appareils partagés",
    "custom": "défini par l'utilisateur",
    "continuous": "en continu (24h/j)",
    "immediately": "tout de suite",
    "notificationPeriod": "Période de notification",
    "monitoringPeriod": "Période de temps de la surveillance",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "abbreviation": {
      "example": "p. ex."
    },
    "price": "Prix",
    "functions": "Fonctions",
    "required": "Obligatoire",
    "errorReport": "Rapport d'erreurs",
    "permanent": "de durée illimitée",
    "at": "à",
    "oClock": "heures",
    "unsubscribed": "annulé(e)",
    "every": "chaque",
    "pixel": "Pixel",
    "lagging": "Cher client,<br><br>L'accès à VBus.net est actuellement ralenti.<br>Nous nous efforçons de résoudre le problème et nous excusons de la gêne occasionnée. Merci de votre compréhension.<br><br>Votre équipe VBus.net",
    "offset": "Offset",
    "defaults": "Réglages standards",
    "deleteAll": "Effacer tous",
    "mustSelectOneOption": "Vous devez sélectionner au moins une option !",
    "browserNotSupported": "Votre navigateur n'est pas compatible!<br/>Veuilliez utiliser une version actuelle.",
    "uploadErrorFile": "Le fichier ne peut pas être chargé ! ",
    "errorSensor": "Erreur de sonde",
    "new": "Nouveau",
    "energyOffset": "Offset pour les valeurs d'énergie",
    "weatherData": "Données météorologiques de votre emplacement",
    "gridLiveSystem": "Fonction quadrillage pour un positionnement plus facile",
    "dailyEnergyValues": "Résumé du jour des valeurs d'énergie",
    "overwriteWarning": "Les données existantes seront écrasées !",
    "maxFilesize": "Taille maximale du fichier",
    "factor": "Facteur",
    "removeConversions": "Enlever conversions",
    "chooseAltUnit": "Sélectionner unité d'affichage alternative…",
    "content": "Contenus",
    "additionalContent": "Autres contenus",
    "choseContent": "Sélectionner contenus",
    "publicLinkDiagrams": "Liens publics vers les diagrammes",
    "publicLinkSchemes": "Liens publics vers les systèmes en direct",
    "deviceInfo": "Information sur l'appareil",
    "noEnergyValuesInFilter": "Le filtre sélectionné ne comporte pas de valeurs d'énergie !",
    "warningSelectOnValue": "Vous devez sélectionner au moins une valeur du filtre !",
    "heatQuantityDay": "Quantité de chaleur jour",
    "heatQuantityWeek": "Quantité de chaleur semaine",
    "heatQuantityMonth": "Quantité de chaleur mois",
    "heatQuantityTotal": "Quantité de chaleur au total",
    "errorMessages": "Messages d'erreur",
    "temperatureValuesIn": "Valeurs de température en ",
    "operator": "Utilisateur du système",
    "systemType": "Type de système",
    "showLiveSystem": "Afficher système en direct",
    "confirmationMail": "E-mail de confirmation",
    "noConfirmationMailreceived": "Vous n'avez pas reçu un e-mail de confirmation ?",
    "backupHintReceivers": "Cet e-mail de confirmation doit être envoyé manuellement aux destinataires.",
    "notificationInterval": "Intervalle de notification",
    "oneEnergyInFilter": "Le filtre doit avoir au moins une valeur d'énergie !",
    "iUnderstand": "J'ai compris.",
    "useCookies": "Ce site web utilise des cookies.",
    "whatsNew": "Nouveautés",
    "nameTelefon": "Téléphone: +49 (0) 23 24/96 48-0",
    "nameFax": "Fax: +49 (0) 23 24/96 48-755",
    "nameEmail": "info@dvm-cloud.net",
    "slide1": "Diagrammes individuels",
    "slide2": "Systèmes en direct",
    "slide3": "Rapports automatiques par e-mail",
    "slide4": "Comment ça marche ?",
    "nextSteps": "Prochaines étapes",
    "clickHereForMoreInformation": "Cliquez ici pour en savoir plus…",
    "clickHere": "Cliquez ici…",
    "learnMore": "Plus d'informations…",
    "firstSteps": "Premières étapes dans VBus.net",
    "deviceName": "Nom de l'appareil",
    "forWeatherData": "Pour les données météorologiques",
    "dataloggerOrCommunicationModule": "Datalogger DL2/DL3 ou module de communication KM2",
    "downloadComplete": "Téléchargement terminé",
    "automaticallyConfirmed": "Votre adresse e-mail (dans \"Mon profil\") est activée automatiquement. Les nouveaux destinataires des e-mail doivent d'abord valider la réception.",
    "downloaded": "téléchargé",
    "templates": "Modèle",
    "template": "Modèles",
    "addTemplate": "Ajouter modèle",
    "noTemplateAvailable": "Aucun modèle n'est disponible pour ce système.",
    "templateAdded": "Le modèle a été ajouté avec succès.",
    "channel": "Canal",
    "vbusConnection": "Connexion VBus",
    "optional": "optionnel",
    "unknownError": "Une erreur inconnue s'est produite",
    "menuLanguage": "Langue du menu",
    "reloadPageNow": "Recharger ce site maintenant",
    "noDevicesFound": "Aucun appareil trouvé sur le VBus.",
    "Haftungsausschluss": "Clause de non responsabilité",
    "PrivacyPolicy": "Déclaration de protection de données",
    "TermsOfUse": "Conditions Générales de Vente",
    "Verantwortlich55RStV": "Responsable du contenu selon § 55 Abs. 2 RStV (Traité d'Etat allemand sur la radiodiffusion)",
    "UmsatzsteuerIdUg": "Numéro d’identification de l’impôt sur le chiffre d’affaires conformément au § 27 a Loi sur l’impôt sur le chiffre d’affaires",
    "VertGeschFuehrer": "Gérant, responsable",
    "DsgvoStart": "Le 25 mai, le nouveau Règlement général sur la protection des données (DSGVO) va entrer en vigueur.",
    "DsgvoStarted": "Le 25 mai, le nouveau Règlement général sur la protection des données (DSGVO) est entré en vigueur.",
    "DsgvoText": "Le Règlement général sur la protection des données (DSGVO) comporte des vastes règlements et obilgations d'information relatifs au traitement et à la protection des données personnelles.",
    "acceptEulaMessage": "Accepter conditions d’utilisation et déclaration de confidentialité.",
    "weather": "Informations météorologiques",
    "other": "Autres",
    "fullscreen": "Plein écran",
    "createFilterFirst": "Vous devez d'abord créer un filtre…",
    "deviceFilter": "Filtre d'appareil",
    "filterLisyByOnlineStatus": "Filtrer liste par état connecté",
    "filterLisyByDeviceType": "Filtrer liste par type d'appareil",
    "sorting": "Triage",
    "noDataLoaded": "Pas de données chargées. Veuillez recharger la page !",
    "showLegend": "Afficher légende",
    "symbol": "Symbole",
    "chooseHeatQuantities": "Vous pouvez sélectionner jusqu'à 3 quantités de chaleur",
    "twoFactorAuthentication": "Authentification à deux facteurs (2FA)",
    "faq": "Questions posées fréquemment",
    "copyToClipboard": "Copier dans le presse-papiers",
    "worst": "très mauvaise",
    "bad": "mauvaise",
    "weak": "faible",
    "good": "bonne",
    "strong": "très bonne",
    "automaticUpdate": "Mise à jour automatique dans __SECONDS__  secondes.",
    "axisSettings": "Réglages des axes",
    "engaged": "On",
    "off": "Off",
    "setup2FA": "Configurer authentification à deux facteurs",
    "remove2FA": "Supprimer authentification à deux facteurs",
    "setupShort2FA": "Configurer 2FA",
    "removeShort2FA": "Supprimer 2FA",
    "recovery2FA": "Codes de restauration",
    "qr2FA": "QR-Code",
    "authenticator2FA": "Code d'authentification",
    "code12FA": "Vous pouvez utiliser des codes de restauration pour accéder à votre compte VBus.net, si vous n'avez pas d'accès à votre application d'authentification à deux facteurs.",
    "code22FA": "Veuillez traiter les codes de restauration avec la même attention que vous porteriez à votre mot de passe. Nous vous recommandons l'enregistrement des codes dans un gestionnaire de mot de passe.",
    "code32FA": "Les codes de restauration ne peuvent être utilisés pour se connecter qu'une seule fois. Après la connexion avec succès, ils ne sont plus valables.",
    "code42FA": "Enregistrez ou imprimez vos codes de restauration avant de procéder à la configuration de l'authentification à deux facteurs.",
    "code52FA": "Au cas ou vous perdriez les codes de restauration et n'auriez plus d'accès à votre application d'authentification, il ne vous sera plus possible de se connecter !",
    "print": "Imprimer",
    "code62FA": "Veuillez scanner le code-barres avec votre application d'authentification puis cliquez sur CONTINUER.",
    "code72FA": "Veuillez saisir le code de votre application d'authentification et cliquer sur TERMINER",
    "finish": "Terminer",
    "invalid2FA": "Le code d'authentification saisi est invalide. Veuillez réessayer.",
    "success2FA": "Votre authentification à deux facteurs a été configurée avec succès !",
    "examples": "Aide",
    "notPossibleMobile": "Cette fonction n'est pas disponible sur des terminaux mobiles !",
    "dateAndTime": "Date et heure",
    "deviceOverview": "Vue d'ensemble des appareils",
    "deviceMap": "Carte de localisation des appareils",
    "minimumSize": "Taille minimale",
    "maximumSize": "Taille maximale",
    "activation": "Activation",
    "switchToPro": "Passer à l'accès PRO maintenant",
    "documentNotFound": "Le document spécifié n'a pas pu être trouvé sur notre serveur.",
    "startPage": "Page d'accueil",
    "clear": "Récupérer",
    "helpAndSupport": "Aide & assistance",
    "fileUpload": "Charger fichier",
    "fileUploadText": "Chargement du ficher __FILENAME__ vers serveur en cours. Veuillez patienter…",
    "unsupportedFileType": "Type de fichier incompatible !",
    "invalidCharactersFilename": "Le nom du ficher ne doit contenir ni caractères spéciaux, ni accents !",
    "invalidFileSize": "Le fichier est trop grand ! (15 MB au maximum)",
    "errorLoadData": "Erreur lors du chargement des données !",
    "unknownExceptionError": "Erreur d'exception inconnue",
    "demoDevice": "Appareil de démonstration",
    "friendDevice": "Appareil partagé",
    "temperatureSensor": "Sonde de température",
    "switch": "Interrupteur",
    "alreadyClaimedDemo": "Vous avez déjà ajouté un Datalogger de démonstration à votre compte.",
    "function": "Fonction",
    "convertValue": "Convertir valeur",
    "tokenNotWorking": "Dommage, ça n'a pas fonctionné. Veuillez essayer un autre code d'accès/coupon.",
    "divisionByZero": "Division par 0 !",
    "passwordStrength": "Force du mot de passe",
    "chartType": "Type de diagramme",
    "autoscale": "Graduer automatiquement",
    "time": "Heure",
    "factoryDefault": "Réglage d'usine",
    "initialize": "Initialisation",
    "addDataloggerCommunicationModule": "Cliquez ici pour ajouter un module de communication ou un Datalogger à votre compte.",
    "twoFactorRemovedSuccessful": "Votre authentification à deux facteurs a été enlevée avec succès !",
    "hideLegend": "Masquer légende",
    "warningUnknownLivedata": "Erreur lors de la lecture des données en direct !",
    "default": "Standard",
    "passwordIsEmail": "Ne pas utiliser l'adresse e-mail comme mot de passe !",
    "unknownDevice": "Appareil inconnu",
    "noSettingsAvailable": "Aucun réglage disponible !",
    "errorLoadImage": "",
    "errorLoadWeather": "",
    "errorLoadLiveSystem": "",
    "weekday": "",
    "createdAt": "",
    "tooltip": "",
    "subtitle": "",
    "lastUpdated": "",
    "preview": "",
    "extendSubscription": "",
    "loginToExtendSubscription": "",
    "orderedSubscription": "",
    "yourAccount": "",
    "unlimited": "",
    "emailAlreadyExists": "",
    "selectDecices": "",
    "description": "",
    "decimals": "",
    "needInvoice": "",
    "proAccount": "",
    "businessAccount": "",
    "convertFilterValue": "",
    "doNotShowAgain": "",
    "toggle": "",
    "numberFormat": "",
    "checkVBusConnection": "",
    "liveDataNotUpToDate": "",
    "news": "",
    "hide": "",
    "archive": "",
    "noNewMessages": "",
    "messages": "",
    "viewArchivedMessages": "",
    "readNow": "",
    "customerOpinions": "",
    "globalErrorTitle": "",
    "globalErrorMessage": "",
    "globalSuccessTitle": "",
    "globalSuccessMessage": "",
    "endOfQuarter": "",
    "lastQuarter": "",
    "licenseText": "",
    "invalidToken": "",
    "selectDay": "",
    "selectCalendarWeek": "",
    "selectMonth": "",
    "selectYear": "",
    "calendarWeek": "",
    "calendarWeekShort": "",
    "selectQuarter": "",
    "dataloggerDL2Plus": "Datalogger DL2 Plus",
    "geodataFormatDecimal": "",
    "geodataFormatSexagesimal": "",
    "noData": "",
    "automaticConversion": ""
  },
  "vbusnet": {
    "email": {
      "confirmText": "Nous vous remercions pour votre inscription sur VBus.net. Le lien ci-dessous vous permet de valider votre compte :",
      "confirmMyAccount": "Valider mon compte",
      "requestNewPassword": "Quelqu'un a sollicité un lien pour changer votre mot de passe. Vous pouvez changer votre mot de passe en cliquant sur le lien ci-dessous.",
      "changeMyPassword": "Changer mon mot de passe",
      "didNotRequestThisText": "Si vous n'avez pas sollicité de lien, veuillez ne pas tenir compte de ce mail.",
      "passwordWontChangeText": "Votre mot de passe restera inchangé à part si vous cliquez sur le lien ci-dessus pour créer un nouveau mot de passe."
    },
    "demo_ownership_description": "Ce Datalogger de démonstration met à votre disposition les données d'une installation de chauffage solaire thermique située dans l'ouest de l'Allemagne. Les données VBus les plus intéressantes sont les suivantes :",
    "demo_datalogger": "Le Datalogger de démonstration ne dispose que de fonctions de traitement limitées."
  },
  "visualization": {
    "scheduledDownloadBodyAttachment": "Vous trouverez en pièce jointe votre téléchargement planifié.",
    "scheduledDownloadBodyNoAttachment": "Cet e-mail ne contient pas de téléchargement planifié. Il n'y a probablement pas de données pour la période sélectionée.",
    "scheduledDownloadSubjectDaily": "Votre téléchargement quotidien planifié",
    "scheduledDownloadSubjectWeekly": "Votre téléchargement hebdomadaire planifié",
    "scheduledDownloadSubjectMonthly": "Votre téléchargement mensuel planifié",
    "report": "Rapport",
    "reportConfirmSubject": "Veuillez valider le nouveau rapport.",
    "scheduledDownload": "Télechargement planifié",
    "scheduledDonwloadConfirmSubject": "Veuillez valider le nouveau téléchargement planifié.",
    "scheduledDownloadConfirmMessage": "Si vous souhaitez être informé sur le téléchargement planifié suivant par e-mail, cliquez sur le lien ci-dessous :",
    "scheduledDownloadUnsubscribe": "Supprimer la récéption des e-mails sur ce téléchargement planifié.",
    "reportConfirmMessage": "Si vous souhaitez être informé sur le rapport suivant par e-mail, cliquez sur le lien ci-dessous :",
    "reportUnsubscribe": "Supprimer la récéption des e-mails sur ce rapport.",
    "nameImage": "Image",
    "nameFilter": "Filtre",
    "nameDiagram": "Diagramme",
    "nameScheme": "Système",
    "maxCustomerImages": "Permet de charger uniquement 3 images personnelles",
    "accepting": {
      "text": {
        "eula": "Accepter le contrat de licence d'utilisateur et l'accord concernant la protection des données",
        "accept": "Accepter maintenant"
      }
    },
    "downloadFormatTextTabWin": "Texte (tabulateur, Windows)",
    "downloadFormatTextSemWin": "Texte (point-virgule, Windows)",
    "downloadFormatTextTabLin": "Texte (tabulateur, Linux)",
    "downloadFormatTextSemLin": "Texte (point-virgule, Linux)",
    "downloadFormatVbus": "Protocole de données VBus",
    "nameDownload": "Téléchargement",
    "nameReport": "Rapport",
    "addScheduledDownload": "Ajouter nouveau téléchargement planifié",
    "enabling": {
      "text": {
        "vbusnet": "Autoriser l'affichage avec VBus.net",
        "eula": "En activant cette option, vous acceptez que notre service enregistre vos données conformément au <a href='/eula'>contrat de licence d'utilisateur final</a> !"
      }
    },
    "allowParameterizationTextPlain": "Autoriser la configuration avec l'adresse Via et le RESOL Parameterization Tool (RPT)",
    "settings": "Configuration de l'affichage",
    "allowParameterizationText": "Autoriser la configuration avec l'adresse Via et le <a href='http://www.resol.de/index/software/sprache/en' target='_blank'>RESOL Parameterization Tool (RPT)</a> ",
    "scheduledDownloads": "Télechargements planifiés",
    "myImage": "Mon image",
    "myFilter": "Mon filtre",
    "myScheme": "Mon système",
    "myDiagram": "Mon diagramme",
    "myDownload": "Mon téléchargement",
    "myScheduledDownload": "Mon téléchargement planifié",
    "myReport": "Mon rapport",
    "myWeather": "Mes informations météorologiques",
    "downloadButton": "télécharger",
    "saveButton": "enregistrer",
    "showButton": "afficher",
    "reportsSelectPeriod": "Veuillez choisir une période de temps",
    "extendedReportsInfo": "Recevez régulièrement des informations sur l'état de votre système par e-mail. Recevez par exemple une fois par semaine des informations sur le rendement (sous forme de diagramme), des messages d'erreur, etc.",
    "extendedReportsWeekInfo": "Si vous sélectionnez \"Hebdomadaire\", vous recevrez les données de la <strong>semaine dernière</strong> à partir du jour sélectionné.",
    "extendedReportsMonthInfo": "Si vous sélectionnez \"Mensuel\", vous recevrez les données du <strong>mois dernier </strong>le premier jour du mois à l'heure souhaitée.",
    "extendedReportsYearChart": "Vue d'ensemble de l'année",
    "extendedReportsWithYearChart": "Avec vue d'ensemble de l'année",
    "extendedReportsFilterInfo": "Un diagramme va être créé pour les données sélectionnées. Il est également possible de créer un diagramme de l'année si vous le souhaitez.",
    "sendReportAfterSave": "Envoyer rapport après enregistrement.",
    "sendScheduledDownloadAfterSave": "Envoyer téléchargement planifié après  enregistrement.",
    "sendScheduledDownloadNow": "Envoyer téléchargement planifié maintenant.",
    "sendReportNow": "Enoyer rapport maintenant",
    "sendScheduledDownloadNowDialog": "Voulez-vous activer votre téléchargement planifié maintenant et le recevoir par e-mail ?",
    "sendReportNowDialog": "Voulez-vous activer votre rapport maintenant et le recevoir par e-mail ?",
    "scheduledDownloadSubjectQuarter": ""
  },
  "monitoring": {
    "weeklyReport": "Votre rapport hebdomadaire",
    "monthlyReport": "Votre rapport mensuel",
    "notificationConnectMail": "Vous recevrez un e-mail une fois la connexion rétablie.",
    "notificationDisconnected": "La connexion à l'appareil est interrompue !",
    "notificationStillDisconnected": "La connexion à l'appareil est encore  interrompue !",
    "notificationDisconnectedNoMail": "Vous ne recevrez plus d'é-mails concernant l'interruption de la connexion.",
    "notificationConnected": "La connexion à l'appareil a été rétablie.",
    "errormaskTrue": "Le masque d'erreurs signale une erreur",
    "errormaskFalse": "Le masque d'erreurs ne signale aucune erreur",
    "mailer": {
      "warning": {
        "subject": "Avertissement"
      },
      "error": {
        "subject": "Erreur"
      },
      "notificationConfirm": {
        "subject": "Veuillez valider la nouvelle notification."
      },
      "connection": {
        "subject": "Etat de la connexion"
      },
      "notification": {
        "message": "Si vous souhaitez être informé sur la notification suivante par e-mail, cliquez sur le lien ci-dessous :",
        "urlText": "Valider cette adresse e-mail.",
        "unsubscribe": "Supprimer la récéption des e-mails sur cette notification."
      },
      "userText": "Texte d'utilisateur"
    },
    "thresholdTrue": "Valeur limite atteinte",
    "repealed": "résolu",
    "notification": "Notification",
    "statusHasChanged": "L'état d'une des conditions de la notification suivante a été modifié.",
    "allConditionsAreFulfilled": "Toutes les conditions de la notification suivante sont remplies.",
    "notificationConfirmed": "Votre adresse e-mail a été validée avec succès.",
    "notificationAlreadyConfirmed": "Votre adresse e-mail a déjà été validée.",
    "notificationInvalidToken": "Code de confirmation non valide !",
    "timePeriod": "Période de temps",
    "receiver": "Destinataire",
    "addNewReceiver": "Ajouter nouveau destinataire",
    "errorOccurred": "Une erreur s'est produite",
    "errorEliminated": "L'erreur a été corrigée",
    "add": {
      "notification": "Ajouter nouvelle notification",
      "action": "Ajouter nouvelle action"
    },
    "notificationConnectionMessage": "La connexion à votre appareil est surveillée automatiquement !<br> Si l'appareil n'est pas connecté à  VBus.net pendant plus de {1} minutes, vous recevrez un e-mail concernant l'interruption de la connexion. Vous serez informé deux fois après respectivement 24 heures sur l'interruption de la connexion. Dès que la connexion est rétablie, vous recevrez un e-mail.",
    "errorLog": "Protocole d'erreurs",
    "myNotification": "Ma notification",
    "conditions": "Conditions",
    "addNewCondition": "Ajouter nouvelle condition",
    "selectDatapoint": "Veuillez sélectionner des données",
    "actions": "Actions",
    "allConditionsFulfilled": "toutes les conditions doivent être remplies",
    "oneConditionFulfilled": "au moins une condition doit être remplie",
    "message": "Message ",
    "hintNotification": "Vous devez ajoutez au moins une condition et une action pour enregistrer une notification !",
    "edit": {
      "notification": "Modifier notification"
    },
    "delete": {
      "notification": "Supprimer notification ?"
    },
    "criterion": "Critère",
    "delay": "Décalage",
    "trippingTime": "Temps de déclenchement",
    "receivers": "Destinataires",
    "numberOfConditions": "Nombre de conditions",
    "allConditionsFulfilled ": "toutes les conditions doivent être remplies",
    "oneConditionFulfilled ": "au moins une condition doit être remplie",
    "addNewTemperatureNotification": "Ajouter nouvelle notification de température",
    "addNewErrorNotification": "Ajouter nouvelle notification d'erreurs",
    "overriding": "Dépassement haut",
    "lower deviation": "Dépassement bas",
    "warning": {
      "value": "Valeur d'avertissement"
    },
    "error": {
      "value": "Valeur d'erreur"
    },
    "numberOfActions": "Nombre d'actions",
    "action": "Action",
    "relatedActions": "Actions liées",
    "threshold": "Seuil",
    "warningThreshold": "Seuil d'avertissement",
    "errorThreshold": "Seuil d'erreur",
    "absoluteValue": "Valeur absolue",
    "difference": "Différence",
    "minimum": "Minimum",
    "maximum": "Maximum",
    "greaterOrEqual": "supérieur(e) ou égal(e) à",
    "lessOrEqual": "inférieure(e) ou égal(e) à",
    "greaterThan": "supérieur(e) à",
    "lessThan": "inférieur(e) à ",
    "unequal": "inégal(e)",
    "dailyReport": "Votre rapport quotidien",
    "reportMessageBodyAttachment": "Vous trouverez en pièce jointe votre rapport.",
    "reportMessageBodyNoAttachment": "Cet e-mail ne contient pas de rapport. Il n'y a probablement pas de données pour la période sélectionée.",
    "currentValue": "Valeur actuelle",
    "condition": "Condition",
    "disconnectionNotification": "",
    "noDisconnectionNotification": ""
  },
  "account": {
    "emailNewConfirmation": "Valider nouvelle adresse e-mail",
    "changeEmailBodyText": "Vous avez changé votre adresse e-mail. Pour valider cette adresse e-mail, cliquez sur le lien ci-dessous :",
    "activation": {
      "error": "Une erreur s'est produite. Veuillez répéter cette opération."
    },
    "changeEmailSuccessful": "La nouvelle adresse e-mail a été validée avec succès.",
    "emailNew": "Nouvelle adresse e-mail",
    "changeEmail": "Changer adresse e-mail",
    "areYouSure": "Êtes-vous sûr ?",
    "username": "Nom d'utilisateur",
    "cancel": "Supprimer mon compte",
    "unhappy": "Vous n'êtes pas satisfait ?",
    "deleteMyAccount": "Supprimer mon compte",
    "changePassword": "Changer le mot de passe",
    "create": {
      "user": "Créer un nouveau compte"
    },
    "edit": {
      "user": "Configurer le compte"
    },
    "password": {
      "CurrentPasswordMessage": "Nous avons besoin de votre mot de passe actuel pour valider les modifications effectuées"
    },
    "understoodEulMessage": "Je déclare avoir lu et compris le <a href='/eula'>contrat de licence d'utilisateur final</a>.",
    "emailConfimationText": "Un lien de confirmation a été envoyé à votre adresse mail. Cliquez sur ce lien pour activer votre compte.",
    "passwordNew": "Nouveau mot de passe",
    "passwordOld": "Ancien mot de passe",
    "passwordNewConfirmation": "Validez le nouveau mot de passe",
    "userData": "Données d'utilisateur",
    "invalid_token": "Vous avez activé votre compte VBus.net avec succès. Vous pouvez vous connecter avec vos données d'accès.",
    "emailOrUsername": "E-mail ou nom d'utilisateur",
    "changeEmailInServices": "Si vous changez votre adresse e-mail, celle-ci sera également changée dans les services suivants :",
    "changeEmailConfirmation": "Un e-mail de confirmation a été envoyé à __EMAIL__. Cliquez sur le lien dans l'e-mail pour valider la nouvelle adresse.",
    "acceptEulaMessage": "Accepter conditions d’utilisation et déclaration de confidentialité.",
    "AcceptEula": "Pour continuer l'utilisation de VBus.net, vous devrez accepter nos conditions d’utilisation et la déclaration de confidentialité."
  },
  "order": {
    "yourOrderSubject": "Votre commande chez VBus.net",
    "salesTaxIdentificationNumber": "Numéro de TVA",
    "positions": "Postes",
    "oneYearPro": "1 x accès VBus.net PRO  (1 an) 39,00 €",
    "bankDetails": "Coordonnées bancaires",
    "paymentDetails": "En raison de la modalité de paiement par virement bancaire, vous recevrez immédiatement la facture par e-mail. Veuillez utiliser les coordonnées bancaires qui y figurent et indiquer le numéro de facture ainsi que votre adresse e-mail VBus.net pour effectuer le virement. Cela nous permettra d'identifier votre paiement.",
    "activatedAfterPayment": "Après avoir reçu le paiement, nous activerons votre accès VBus.net PRO.",
    "upToThreeDays": "Cette opération peut durer jusqu'à 3 jours.",
    "reference": "Motif paiement",
    "paymentMethod": "Modalité de paiement",
    "order": "Commande",
    "confirmation": "Vous recevrez dans quelques minutes une validation de commande par e-mail contenant des informations sur le paiement. Après avoir reçu le paiement, nous activerons votre accès VBus.net PRO.",
    "paymentPaypal": "Paiement par Paypal",
    "paymentBankTransfer": "Paiement par virement bancaire",
    "paymentPerMail": "Facture par e-mail à",
    "now": "Commander maintenant",
    "linkAgb": "Nos Conditions Générales de Vente CGV sont applicables",
    "mustConfirm": "Vous devez d'abord valider la commande",
    "VbusVisulizationVor2013": "Commander l'accès à VBus.net pour les DL2 produits avant 2013",
    "withCost": "Commander ici (payant)",
    "VbusVisulization": "Oui, je souhaite commander l'accès à VBus.net",
    "description": "Les frais d'achat du droit d'accès à l'affichage VBus.net s'élèvent à <b>20 euros (prix TTC) (paiement unique)</b>.<br/>Vous recevrez un mail de confirmation peu après après avoir effectué votre commande.",
    "umstid": "Numéro de TVA",
    "billingAdressAdd": "Adresse de facturation (si celle-ci est différente de l'adresse personnelle)",
    "dl2": {
      "bevor2012": "Accès VBus.net pour les DL2 avant 2013",
      "thanks": "Merci d'utiliser VBus.net. Vous avez dès maintenant accès à votre appareil et pouvez utiliser les fonctions avancées."
    },
    "vatIncluded": "TVA incluse",
    "salutaion": "Monsieur/Madame",
    "thanksForOrder": "nous vous remercions de votre commande datée du",
    "orderDetails": "Détails sur votre commande :",
    "emailReference": "Pour effectuer le virement bancaire, veuillez indiquer votre adresse e-mail comme motif paiement. Cela nous permettra d'identifier votre paiement.",
    "sendOrder": "Envoyer commande",
    "accountUpdated": "",
    "currentSubscription": "",
    "newSubscription": "",
    "validUntil": "valable jusqu'à"
  },
  "professional": {
    "willExpire": "Votre accès VBus.net PRO va expirer dans {1} jours.",
    "order": {
      "euvat": {
        "explanation": "Je confirme par la présente que ma résidence principale est située dans le pays mentionné ci-dessus. Cela sert de base pour calculer le T.V.A. (uniquement dans l'UE)"
      },
      "information": {
        "required": "Informations requises"
      },
      "require": {
        "text": "Le vendeur de cet article a besoin des informations suivantes :"
      },
      "received": "Nous avons reçu votre paiement PayPal.",
      "thanks": "Merci d'utiliser VBus.net PRO. Vous avez dès maintenant accès à VBus.net PRO et pouvez utiliser les fonctions avancées.",
      "redirect": {
        "wait": "Votre commande vient d'être envoyée à PayPal.",
        "wait2": "Cette opération peut durer quelques secondes."
      }
    },
    "own": {
      "scheme": {
        "images": "Propres images du système"
      }
    },
    "data": {
      "live": {
        "time": "Stockage de données"
      }
    },
    "function": {
      "overview": "Vue d'ensemble des accès VBus.net"
    },
    "time": {
      "live": {
        "data": "Mise à jour de données"
      }
    },
    "enhanced": {
      "scheme": {
        "editor": "Editeur de système avancé"
      }
    },
    "dl2": {
      "inclusive": "Accès pour les DL2 avant 2013 incl."
    },
    "error": {
      "protocol": "Protocole d'erreurs"
    },
    "monitoring": "Notifications",
    "friendship": {
      "function": "Partager appareil"
    },
    "subscription": {
      "name": {
        "basic": "Basic",
        "professional": "PRO"
      }
    },
    "subscriptionRequired": "Vous devez disposer d'un accès VBus.net PRO pour réaliser cette action.",
    "expired": "Expiré",
    "extendOneYear": "Prolonger d'un an (payant)"
  },
  "extend": {
    "professional": {
      "account": "Prolonger l'accès PRO"
    }
  },
  "address": {
    "herr": "Monsieur",
    "frau": "Madame",
    "billingAddress": "Adresse de facturation",
    "firma": "Entreprise",
    "anrede": "Titre",
    "vorname": "Prénom",
    "nachname": "Nom de famille",
    "strasse1": "Rue 1",
    "strasse2": "Rue 2",
    "postleitzahl": "Code postal",
    "ort": "Localité",
    "plz": "CP",
    "land": "Pays",
    "businessCustomer": "Client d'entreprise",
    "privateCustomer": "Client privé",
    "email": "E-mail",
    "telefon": "Téléphone",
    "fax": "Fax",
    "internet": "Internet",
    "strasse": "Rue",
    "bundesland": "Région",
    "kundennummer": "Numéro client",
    "webseite": "Site Internet",
    "name": {
      "first": "Prénom",
      "last": "Nom"
    },
    "address": "Adresse",
    "kunde": "Client"
  },
  "backbone": {
    "validation": {
      "required": "est requis(e)",
      "email": "doit être une adresse e-mail valide",
      "acceptance": "doit être validé(e)",
      "min": "doit être supérieur(e) ou égal(e) à {1}",
      "max": "doit être inférieur(e) ou égal(e) à {1}",
      "range": "doit être entre {1} et {2}",
      "length": "doit avoir {1} caractères",
      "minLength": "doit avoir au moins {1} caractères",
      "maxLength": "doit avoir au plus {1} caractères",
      "rangeLength": "doit avoir entre {1} et {2} caractères",
      "oneOf": "doit avoir : {1}",
      "equalTo": "doit être égal(e) à {1}",
      "digits": "doit avoir uniquement des chiffres",
      "number": "doit être un chiffre",
      "url": "doit être une URL valide",
      "inlinePattern": "non valide",
      "matchPasswords": "Les mots de passe ne sont pas identiques",
      "matchEmail": "Les adresses e-mail ne sont pas identiques.",
      "compareWithOriginalEmail": "La nouvelle adresse e-mail ne doit pas être identique à l'adresse actuelle."
    }
  },
  "errors": {
    "messages": {
      "already_confirmed": "a déjà été confirmé(e)",
      "prohibited": {
        "ownership": {
          "one": "1 error prevented this device ownership from being saved:",
          "others": "2 errors prevented this device ownership from being saved:"
        }
      }
    }
  },
  "passwordWrong": "Le mot de passe est incorrect. Veuillez vérifier votre saisie !",
  "ownership": {
    "invalidToken": "Code d'accès (token) non valide.",
    "alreadyClaimed": "Cet appareil a déjà été ajouté !",
    "successfully": {
      "created": "L'appareil a été mis à jour correctement.",
      "deleted": "L'appareil a été supprimé avec succès !"
    },
    "alreadyInOwnAccount": "Cet appareil était disponible sur votre compte. Si vous souhaitez le restaurer, veuillez sélectionner l'appareil correspondant dans la liste.<br>Si vous souhaitez ajouter l'appareil comme Nouvel appareil, les données précédentes ne seront pas restaurées.",
    "alreadyInOtherAccount": "Cet appareil a déjà été ajouté à un compte !<br>L'appareil doit être supprimé de tous les autres comptes ou, s'il s'agit de votre appareil, il doit être restauré. Veuillez prendre en compte les instructions du manuel d'utilisation!",
    "restoreThisDevice": "Restaurer cet appareil",
    "deleteOwnership": "Supprimer appareil",
    "addAsNew": "Ajouter comme Nouvel appareil",
    "confirmText": "Voulez-vous vraiment supprimer cet appareil ?",
    "claim": {
      "online": {
        "message": "Pour pouvoir ajouter un appareil, votre Datalogger ou module de communication doit être connecté à Internet."
      }
    },
    "via_tag": "Identificateur Via",
    "editing": "Modifier appareil",
    "description": {
      "via_tag": "Saississez un identificateur Via et enregistrez-le pour pouvoir personnaliser votre adresse Via. Une fois l'identificateur Via enregistré, vous pourrez utiliser votre adresse Via pour avoir accès aux données de votre système sur Internet.<br/>L'identificateur Via doit avoir au moins 3 caractères et doit commencer par une minuscule. Caractères autorisés : minuscules, chiffres et traits d'union."
    },
    "claimedSuccessful": "Votre __PRODUCT-NAME__ a été ajouté avec succès !",
    "getFirstDataHeader": "Consultation des données en cours… ",
    "getFirstDataSubtext": "Établissement de la connexion en cours. Cette opération peut durer quelques minutes…",
    "dataReceivedSuccessfully": "Données consultées avec succès",
    "initSettingsText": "Veuillez saisir les informations suivantes sur votre appareil :",
    "claimOwnFriendshipToken": "Vous ne pouvez pas utiliser votre code d'accès généré automatiquement !",
    "adjustTimestamps": "",
    "adjustTimestampsInfo": "",
    "openSettings": ""
  },
  "viatag": {
    "alreadyInUse": "Cet identificateur Via est déjà utilisé !"
  },
  "demo": {
    "temperature": {
      "collector": "Température du capteur",
      "storage": {
        "below": "Température du réservoir (en bas)",
        "above": "Température du réservoir (en haut)"
      }
    },
    "pump": {
      "speed": "Vitesse de la pompe"
    },
    "valve": {
      "storage": "Vanne du réservoir"
    },
    "maximum": {
      "count": {
        "exeed": "Le Datalogger de démonstration n'a pu être installé. L'utilisateur peut ajouter un Datalogger de démonstration au maximum !"
      }
    }
  },
  "error": {
    "messages": {
      "not_found": "N'existe pas"
    },
    "noData": {
      "aviable": "Aucune donnée pour les réglages sélectionnés !"
    },
    "tooManyRequests": ""
  },
  "coupon": {
    "claimedSuccessful": "Votre coupon a été utilisé avec succès. Votre accès PRO a été activé / prolongé de :",
    "alreadyClaimed": "Coupon a déjà été utilisé",
    "invalidToken": "Code de coupon non valide",
    "youHaveACoupon": "Vous avez déjà un coupon ?",
    "code": "Code de coupon",
    "redeemCoupon": "Utiliser coupon",
    "name": "Coupon",
    "enterCouponCode": "Saisissez le code de coupon ici",
    "redeemAnotherCoupon": "Utiliser coupon supplémentaire",
    "deviceWithTestPro": "Votre nouvel appareil inclut un coupon - testez VBus.net PRO gratuitement pendant 30 jours !",
    "redeemNow": "Utiliser coupon maintenant ",
    "redeemLater": "Utiliser coupon plus tard",
    "redeemLaterText": "Vous pouvez également utiliser votre coupon plus tard - votre code : __COUPON__ (celui-ci se trouve aussi au verso du manuel)."
  },
  "device": {
    "notFound": "L'appareil n'a pas été trouvé.",
    "newFirmwareAvailable": "Une nouvelle version du logiciel résident __VERSION__ est disponible !",
    "serial": "Serial",
    "version": "Version",
    "build": "Build",
    "product": "Product",
    "fw_feed": "Fw feed",
    "firmware_feed": "Firmware feed",
    "newFirmware": "Nouveau logiciel résident disponible",
    "claimInfoPorts": " Veuillez noter que votre Datalogger (DL2/DL3) ou module de communication (KM2) doit être connecté à Internet et doit avoir accès à VBus.net ! Pour accéder à VBus.net, le Datalogger ou module de communication doit avoir accès illimité aux ports 80 et 1194 / 1195.",
    "claimInfoLed": "Le témoin lumineux LED doit être allumé en vert en permanence",
    "claimVbusActivated": "VBus.net doit être activé",
    "claimInfoNetwork": "doit être affiché dans le menu Reséau",
    "claimInfoNoVisualizationSettings": "Aucun réglage de visualisation disponible pour cet appareil."
  },
  "dataProtection": {
    "Einwilligung": "Consentement relatif à la protection des données",
    "EinwilligungWiderruf": "Vous pouvez annuler à tout moment le consentement en envoyant un <span class=\"nobr\">e-mail</span> à datenschutz@dvm-cloud.net.",
    "EinwilligungText1": "J'ai lu et compris les URL_NUTZUNG ainsi que la URL_DATENSCHUTZ et je les accepte."
  },
  "eula": {
    "acceptWarning": "Vous devez acceptez le contrat de licence d'utilisateur et accord de protection des données pour pouvoir continuer.",
    "agb": "Conditions d'utilisation",
    "privacyPolicy": "Déclaration de confidentialité",
    "reaccept": "Nous avons modifié notre contrat de licence d'utilisateur et l'accord concernant la protection des données. Pour continuer, vous devez d'abord les accepter. ",
    "name": "Contrat de licence d'utilisateur et accord de protection des données",
    "acceptText": "En cliquant sur Créer un compte, vous acceptez __eula__ ."
  },
  "filter": {
    "add": "Ajouter nouveau filtre",
    "showAll": "Afficher toutes",
    "edit": "Modifier filtre",
    "name": "Nom du filtre",
    "addToFilter": "Ajouter au filtre",
    "show": "Afficher",
    "mustBeAString": "Doit être un texte",
    "atLeastOneDatapoint": "Vous devez ajouter au moins un champ de données au filtre.",
    "showUsed": "Uniquement réglages standard modifiés",
    "pleaseSelectDatapoints": "Veuillez sélectionner des données de la liste de vos données en direct.",
    "noFilterData": "Pas de données de filtre disponibles !",
    "changedLiveData": "Vos données en direct ont changé depuis la création du filtre !",
    "noConversionAvailable": "Aucune conversion disponible",
    "conversionError": "Erreur de conversion !",
    "changedLiveDataShowOldValues": "{1} valeurs filtre ne sont plus disponibles dans vos données en direct et ne peuvent plus être modifiées !",
    "maxValues": "Un maximum de {1} valeurs de filtre sont autorisées !",
    "datapointNotEditable": "Vous ne pouvez pas modifier ce point de données."
  },
  "day": {
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "lastTwo": "2 derniers jours",
    "lastSeven": "7 derniers jours",
    "lastThirty": "30 derniers jours",
    "currentMonth": "Mois actuel",
    "lastMonth": "Le mois dernier",
    "sa": "Sam",
    "So": "Dim",
    "do": "Jeu",
    "Di": "Mar",
    "Mi": "Mer"
  },
  "ademe": {
    "module": "Module",
    "filter": {
      "header": "filtrer par modules",
      "units": "filtrer par unités",
      "allModules": "Tous les modules",
      "allUnits": "Toutes les unités"
    },
    "report": {
      "add": "Ajoutez un nouveau rapport",
      "edit": "Modifier rapport",
      "save": "Sauvegarder rapport"
    },
    "add": {
      "header": "ADEME:"
    },
    "systemType": "Type d'installation",
    "systemNumber": "Numéro d'identification",
    "value": "Valeur",
    "values": "Valeurs",
    "error": {
      "systemNumberStart": "Le numéro d'identification doit commencé par IS!",
      "systemNumberLength": "Le numéro d'identification doit avoir entre 12 et 14 caractères !",
      "systemNumberCharacter": "Le numéro d'identification contient des caractères non valides !",
      "systemNumberYear": "Le numéro d'identification ne contient pas d'année valide.",
      "SystemType": "<br />Veuillez sélectionner un type d'installation !"
    },
    "hint": {
      "successSaveHeader": "Avec succès !",
      "successSaveBody": "Vos données ont été enregistrées avec succès !",
      "warningSaveHeader": "Avertissement !",
      "warningSaveBody": "Vous avez déja enregistré les données de votre système. Des modifications peuvent avoir des effets sur votre subvention ADEME !"
    },
    "select": {
      "systemType": "Veuillez sélectionner le type d'installation"
    },
    "system": "Installation",
    "units": {
      "Energy": "Énergie",
      "Temperature": "Température",
      "CubicMeter": "Mètre cube"
    }
  },
  "sideBar": {
    "filters": "Filtre",
    "images": "Images",
    "liveSchemes": "Systèmes en direct",
    "diagrams": "Diagrammes",
    "downloads": "Téléchargements",
    "reports": "Rapports",
    "notifications": "Notifications",
    "visualization": "Affichage",
    "friends": "Partager appareil",
    "dashboard": "Tableau de bord",
    "parametrization": "Paramétrage WebRPT",
    "discovery": "DeviceDiscoveryTool",
    "utilities": "Outils",
    "myVBusNet": "Mon VBus.net",
    "status": "État",
    "ademe": "ADEME",
    "monitoring": "Surveillance"
  },
  "choose": {
    "download": {
      "format": "Veuillez choisir un format de téléchargement"
    },
    "system": "Veuillez choisir un système",
    "background": {
      "image": "Veuillez choisir une image de fond"
    },
    "filter": "Veuillez choisir une sélection de données",
    "periodOfTime": "Veuillez choisir une période de temps",
    "image": "Sélectionner image",
    "device": "Sélectionner appareil"
  },
  "plan": {
    "valid": {
      "until": "Valable jusqu'à"
    },
    "order": {
      "here": "Commander ici"
    },
    "days": {
      "left": "Jours restants"
    },
    "trial": {
      "expired": "LA PÉRIODE D'ESSAI A EXPIRÉ"
    }
  },
  "subtitle": {
    "myDevices": "Mes appareils",
    "myVirtualDevices": ""
  },
  "unit": {
    "add": "+ Ajouter valeur",
    "sub": "- Soustraire valeur",
    "mul": "* Multiplier valeur",
    "div": "/ Diviser valeur",
    "inv": "1 / valeur (valeur inverse)",
    "calculate": "Convertir unité"
  },
  "parameterization": {
    "supportedDevicesText": "Les appareils suivants peuvent actuellement être paramétrés à travers VBus.net :",
    "rptWebseite": "Si votre appareil n'est pas encore compatible avec VBus.net, vous pouvez utiliser notre Logiciel de paramétrage RESOL RPT. Pour plus d'informations, veuillez consulter notre site Web :",
    "connectionRptServer": "Établissement de la connexion au serveur WebRPT en cours…",
    "connectionRptServerError": "La connexion au serveur WebRPT n'a pas pu être établie.",
    "connectionRptServerRetry": "Vérifier à nouveau la connexion …",
    "checkConncectionToDevice": "Vérifier possibilité de paramétrage",
    "notParameterizable": "Ne peut pas être paramétré",
    "vbusPassword": "Mot de passe VBus",
    "passwordHint": "Saisissez le mot de passe pour l'accès à distance (réglage d'usine : vbus).",
    "loadConfig": "Charger des configurations sauvegardées :",
    "pleaseEnterVbusPassword": "Veuillez saisir le mot de passe VBus et cliquer sur CONTINUER.",
    "dataTransmission": "Transfert de données en cours…",
    "configurationNotLoadable": "La configuration n'est pas téléchargeable !",
    "deleteConfiguration": "Supprimer cette configuration ?",
    "errorTimeout": "Dépassement du temps lors de l'établissment de la connexion au Datalogger /module de communication",
    "errorConnection": "Le Datalogger / module de communication n'est pas connecté à VBus.net.",
    "errorNetwork": "Veuillez vérifier le câblage de votre réseau et / ou le Datalogger / module de communication",
    "wrongVbusPassword": "Mode de passe VBus incorrect !",
    "errorNoResponse": "Le régulateur ne répond pas !",
    "errorVbus": "Veuillez vérifier le câble VBus et / ou le régulateur.",
    "errorCode": "Code erreur",
    "errorLogin": "Connexion WebRPT expirée !",
    "login": "Veuillez vous connecter de nouveau !",
    "notParametrizable": " ne peut pas être paramétré.",
    "changedController": "Le régulateur a changé !",
    "withoutConfiguration": "Lancer sans configuration",
    "brokenConfiguration": "Configuration défectueuse",
    "proRequired": "Accès PRO requis",
    "rpt": "Note RPT",
    "start": "Paramétrer  maintenant",
    "connectionController": "Établissement de la connexion au régulateur en cours...",
    "noConnectionVBusnet": "La connexion à VBus.net n'a pas pu être etablie !",
    "checkStep1": "Veuillez vérifier votre DL2/DL3/KM2 et, le cas échéant, les réglages réseau de celui-ci ainsi que vos réglages Internet et pare-feu.",
    "noConnectionController": "La connexion au régulateur n'a pas pu être etablie !",
    "checkStep2": "Veuillez vérifier, si votre régulateur est prêt et si le câble VBus a été connecté correctement. ",
    "wrongPassword": "Mot de passe erroné !",
    "checkStep3": "Veuillez vérifier votre saisie et cliquer ensuite sur CONTINUER.",
    "controllerNotParameterizable": "Régulateur ne peut pas être paramétré.",
    "checkStep4": "Veuillez vérifier, si votre régulateur est compatible avec le paramétrage.",
    "connectionVbusnet": "Connexion à VBus.net",
    "controller": "Régulateur",
    "checkVersion": "Vérification de la version",
    "configurable": "Peut être paramétré ?",
    "getSupportedDevices": "Recherche d'appareils compatibles en cours…",
    "foundSupportedDevices": "Les appareils trouvés suivants peuvent être paramétrés selon leurs versions logicielles :",
    "noSupportedDevices": "Aucun appareil compatible trouvé !",
    "configuration": "Configuration",
    "notAllowed": ""
  },
  "parametrization": {
    "header": "Logiciel de paramétrage RPT ",
    "supportedDevices": "Les régulateurs RESOL suivants sont compatibles :",
    "subHeader": "Logiciel pour le paramétrage à distance des régulateurs RESOL",
    "downloadFree": "Téléchargez gratuitement le logiciel RPT",
    "rptSoftware": "Logiciel RPT (version 1.9)",
    "licenseNote": "License note",
    "manualPdf": "Manuel (PDF)",
    "systemRequirements": "Conditions requises : Windows 7, en mode de compatibilité Windows 8.1/10, Java 32 bit version 1.6. ou supérieure",
    "howToStepOne": "Démarrez le logiciel RPT sur votre ordinateur, puis sélectionnez <strong>Connecter...</strong> dans le menu <strong>Communication</strong>.",
    "howToStepTwo": "Sélectionnez l’appareil utilisé et saisissez votre identificateur Via dans le champ <strong>Adresse URL/IP</strong>.",
    "howToStepThree": "Vous trouverez l’identificateur Via dans le menu ",
    "howToStepFour": "Saisissez votre mot de passe. Le mot de passe par défaut est <strong>vbus</strong>.",
    "howToStepFive": "Cliquez sur <strong>Connecter</strong>. Vous pouvez maintenant paramétrer votre régulateur.",
    "deviceNotListed": "Si votre régulateur ne figure pas sur cette liste, veuillez utiliser le",
    "rscSoftware": "logiciel RSC ",
    "requiredDevices": "Pour pouvoir utiliser le logiciel de paramétrage RPT à travers VBus.net, vous avez besoin des appareils RESOL suivants :",
    "youNeedDevice": "Vous n'avez pas encore d’appareil RESOL ? Cliquez <a href=\"http://www.resol.de/\" target=\"_blank\">ici</a> pour accéder à notre site Internet."
  },
  "settingsDocumentation": {
    "errorTryAgain": "Veuillez réessayer plus tard. Si le problème persiste, veuillez contacter l'équipe Assistance technique : support@resol.de",
    "description": "Le Settings Documentation Generator crée une documentation (PDF) de votre fichier SET.",
    "selectSetFile": "Sélectionner le fichier SET",
    "documentTitle": "Titre du document",
    "convertSetFile": "Convertir le fichier SET",
    "startConversion": "Lancer la conversion",
    "downloadPdfFile": "Télécharger le fichier SET",
    "settingsDocumentationGenerator": "Settings Documentation Generator",
    "optionalTitel": "Titre optionnel",
    "invalidSetFile": "Format du fichier SET invalide",
    "incompatibleSetFile": "Le fichier est un fichier SET incompatible avec le RESOL DeltaSol MX 2.xx. Veuillez essayer un autre fichier. ",
    "convertionFailed": "Échec conversion",
    "errorConversionTookToLong": "La conversion a duré trop longtemps pour terminer.",
    "converting": "Conversion en cours",
    "errorAllowedCharacters": "Caractères admissibles dans le titre : lettres, chiffres, traits d'union (-), espaces ( ) et tirets bas (_).",
    "pdfFile": "Fichier PDF"
  },
  "passwordSame": "Le nouveau mot de passe est identique au mot de passe actuel.",
  "delete": {
    "entry": {
      "text": "Cette saisie ne peut pas être effacée car elle est utilisée dans la ou les fonction(s) suivante(s) :",
      "header": "Effacer saisie",
      "question": "Voulez-vous réellement effacer la saisie <span id='myModalName' class='delete_question'></span> ?"
    }
  },
  "unitFamily": {
    "temperature": "Température",
    "volume": "Volume",
    "pressure": "Pression",
    "power": "Puissance",
    "energy": "Energie",
    "volumeFlow": "Débit",
    "time": "Heure"
  },
  "deleteAccount": "Toutes vos données ainsi que l'accès à VBus.net seront supprimés irrévocablement ! Ce processus ne peut pas être annulé ! Veuillez saisir votre mot de passe actuel pour confirmer l'action.",
  "passwordRequired": "Veuillez saisir votre mot de passe actuel.",
  "yesDeleteAccount": "Oui, supprimer toutes les données",
  "topBar": {
    "editProfile": "Mon profil",
    "registerHere": "Créer un compte gratuitement",
    "imprint": "Mentions légales",
    "register": "Créer un compte",
    "home": "Page d'accueil"
  },
  "passwordHackInfo": "Les spécialistes en informatique ont besoin de <b>TIME</b> pour calculer ce mot de passe ! ",
  "changePasswort": {
    "noToken": "Aucun code d'accès pour la récupération du mot de passe a été trouvé ! Veuillez noter que le code d'accès pour récupérer le mot de passe est valide pour 1 jour. Demandez un nouveau lien, le cas échéant."
  },
  "twoFactorTokenAlredyExists": "Les codes de restauration ne peuvent être créés qu'une fois.",
  "dataviewer": {
    "title": "Pour visualiser les données du système à travers une carte mémoire SD. Les données s'affichent dans un diagramme clair. Vous n'avez pas besoin d'un Datalogger ni d'un module de communication. Le régulateur ne doit pas être connecté à Internet. Vos données ne seront pas sauvegardées."
  },
  "diagram": {
    "add": "Ajouter nouveau diagramme",
    "allow": {
      "public": "Créer un lien vers le diagramme"
    },
    "edit": "Modifier diagramme",
    "data": "Données",
    "height": "Hauteur",
    "width": "Largeur",
    "noDataSelected": "Pas de données sélectionées",
    "min": "Min",
    "max": "Max",
    "publicUrlCustomRangeWarning": "L'option <strong>Période définie librement </strong> n'est pas disponible pour les diagrammes publics."
  },
  "vbus": {
    "deactivateFilter": "Le fichier du protocole VBus contient toutes les valeurs. La fonction Filtre est annulée. ",
    "net": "VBus.net"
  },
  "download": {
    "add": "Ajouter nouveau téléchargement",
    "edit": "Modifier téléchargement",
    "noDataForSelectedPeriod": "Il n'y a pas de données pour la période sélectionée !",
    "forOtherOs": ""
  },
  "tooltip": {
    "filter": {
      "standardvorgabe": "Vous pouvez sauvegarder chaque filtre comme réglage standard et l'utiliser pour créer d'autres filtres. Il vous est possible de créer un réglage standard par appareil."
    }
  },
  "default": {
    "filter": {
      "load": {
        "msg": "Charger réglage standard",
        "text": "Charger filtre comme réglage standard"
      },
      "values": "Réglages standards du filtre",
      "exists": {
        "text": "Vous avez déjà créé un filtre pour cet appareil."
      },
      "default": {
        "text": "Voulez-vous utiliser un filtre comme réglage standard ?",
        "create": "Créer réglages standards pour ce système",
        "load1": "Ajouter réglages standards à la liste",
        "load2": "Modifier la liste avec les réglages standards",
        "load3": "Modifier la liste avec les réglages standards et ajouter les valeurs manquantes"
      }
    },
    "load": "Charger",
    "default": {
      "notexists": {
        "text": "Vous n'avez pas défini un réglage standard pour cet appareil.",
        "text1": "Souhaitez-vous créer un réglage standard pour cet appareil maintenant ?"
      },
      "create": {
        "text": "Créer réglage standard"
      }
    }
  },
  "heating": {
    "systems": "Systèmes de chauffage"
  },
  "solar": {
    "systems": "Systèmes solaires",
    "collectors": "Capteurs",
    "storages": "Réservoirs",
    "collector": "Capteur",
    "system": "Système solaire"
  },
  "image": {
    "add": "Ajouter nouvelle image",
    "name": "Nom de l'image",
    "validMimeType": "L'image doit être au format .jpg, .jpeg, .png ou .gif",
    "edit": "Modifier image",
    "maxFilesize": "Taille maximale du fichier",
    "delete": "Effacer image?"
  },
  "scheme": {
    "allow": {
      "public": "Créer un lien vers le système"
    },
    "setDatapoints": "Positionner les données",
    "add": "Ajouter nouveau système",
    "edit": "Modifier système",
    "publicUrl": "Le lien publique vous permet d'afficher votre système en direct, même si vous n'êtes pas connecté à VBus.net. Vous pouvez partager ce lien avec des personnes qui ne disposent pas d'accès VBus.net. Vous avez également la possibilité d'insérer ce lien sur votre site Internet pour y afficher votre système."
  },
  "reports": {
    "dotDayOfMonth": "jour du mois",
    "dotDay": ". jour le / tous les ",
    "dotMonth": ". mois à"
  },
  "please": {
    "wait": "Veuillez patienter…"
  },
  "parameterizationsettings": {
    "translation": "Réglages de la configuration",
    "makeShureNotDefaultPasswordText": "Vérifiez que le mot de passe qui permet de configurer le régulateur à travers l'interface web du Datalogger n'est pas le mot de passe par défaut 'vbus'.",
    "changePasswordText": "Pour changer ce mot de passe, cliquez sur le lien suivant: "
  },
  "claim": {
    "howToFindToken": "Comment trouver le code d'accès / Token ?"
  },
  "index": {
    "claimANewDevice": "Ajouter un appareil",
    "editThisInformation": "Modifier cette information",
    "welcomeToVBusnet": "Bienvenue sur VBus.net!",
    "youNotHaveADataloggerYet": "Vous n'avez pas d'appareil ? Cliquez ici pour ajouter un Datalogger de démonstration à votre compte...",
    "noVideo": "La vidéo ne marche pas ? Essayez les alternatives suivantes",
    "videoDownload": "Télécharger la vidéo",
    "orOn": "ou sur",
    "ifYouDoNotHaveADataloggerYet": "Si vous souhaitez tester VBus.net mais n'avez pas d'appareil, vous pouvez ajouter un Datalogger de démonstration à votre compte en effectuant les opérations suivantes :",
    "list": {
      "logInToVBusNet": "Connectez-vous à VBus.net",
      "addADemonstationLogger": "Ajoutez un Datalogger de démonstration à votre compte",
      "activateOptionDatalogger": "Activez l'option correspondante dans le Datalogger",
      "getActivationToken": "Notez le code d'accès (token)",
      "claimLoggerWhithToken": "Saisissez le code d'accès (token) pour ajouter l'appareil."
    },
    "download": {
      "datasheet": "Téléchargez ici la<br />fiche technique de VBus.net !",
      "manual": "Téléchargez ici le<br />mode d'emploi de VBus.net !"
    },
    "text1": "VBus.net est une offre de services Internet de <a href=“http://www.resol.fr“>RESOL</a> qui vous permet d'accèder à votre appareil RESOL en quelques clics, où que vous soyez.",
    "text3": "VBus.net porte sur les données de votre régulateur RESOL. Pour avoir accès à ces données, il est cependant nécessaire que vous ajoutiez votre appareil à votre compte. Vous pouvez faire cela en réalisant les quatre simples étapes suivantes :",
    "noVideoPlaybackText": "Votre navigateur ne vous permet pas de voir cette vidéo<SEMICOLON> veuillez télécharger la vidéo suivante.",
    "general": {
      "register": "Testez-le gratuitement et sans engagement"
    },
    "howto": {
      "question": "Vous voulez savoir comment ça marche ?"
    },
    "customer": {
      "examples": "Vous voulez voir comment nos clients utilisent VBus.net ?"
    },
    "title": "Visualisez les données de votre système",
    "text2": "Affichez les températures du système et créez des systèmes en direct individuels et des diagrammes gratuitement.",
    "liveSystemExample": "",
    "createNewVirtualDevice": ""
  },
  "show": {
    "liveData": "Afficher les données en direct"
  },
  "friendship": {
    "createToken": "Créer code d'accès (token)",
    "createdFriendships": "Codes d'accès créés",
    "createAccessTokenText": "<b>Partagez vos données avec d'autres utilisateurs VBus.net...</b><br/><br>Créez un nouveau code d'accès (token) pour un utilisateur VBus.net, pour lui permettre d'accéder à vos données. Il peut ainsi créer des diagrammes, des systèmes en direct, etc. en utilisant les données de votre système. <br/><br/>Il peut ajouter ce code d'accès comme nouvel appareil dans son compte VBus.net dans  <b>Mes appareils <i class=\"fa fa-angle-right\"></i>  Ajouter un appareil</b>. Il suffit de lui donner le code d'accès.<br/><br/> Vous pouvez bien sûr supprimer l'accès à tout moment.",
    "featureNotAvailable": "Cette fonction n'est pas disponible pour un appareil partagé !"
  },
  "feedbackForm": {
    "thankYou": "Merci pour votre feedback.",
    "yourOpinion": "Votre avis nous intéresse !",
    "helpText": "Vous souhaitez contribuer à l'amélioration de VBus.net ou nous communiquer vos idées, souhaits et remarques ? Contactez-nous simplement en utilisant le formulaire feedback.",
    "assessmentText": "Veuillez prendre en compte les points suivants :",
    "scopeOfFunctions": "Gamme de fonctions",
    "userFriendliness": "Simplicité d'utilisation",
    "use": "Utilité",
    "response": "Votre feedback sera traité sous _ID_.",
    "yourSatisfaction": "Votre satisfaction"
  },
  "imprint": {
    "chief": "Représentant légal",
    "court": "Registre du commerce",
    "registration": {
      "number": "Numéro de registre"
    },
    "vat": "Numéro de TVA conformément au paragraphe § 27a de la loi sur la TVA",
    "poweredBy": "Fourni par",
    "technic": {
      "design": "Technique & design Internet"
    }
  },
  "sales": {
    "tax": {
      "act": "(loi allemande Umsatzsteuergesetz)"
    }
  },
  "howto": {
    "vbusdotnet": "VBus.net vous permet de créer des affichages en temps réel de votre système et des diagrammes des données enregistrées ou encore de télécharger des données pendant une période choisie. ",
    "storageDuration": "Vos données seront enregistrées pendant 90 jours (Basic) ou 1 année (PRO).",
    "liveData": "Voyez en direct les données actuelles de votre système.",
    "filter": "Créez des sélections de données pour les utiliser dans vos téléchargements, vos systèmes en direct ou dans vos diagrammes. Vous pouvez changer les noms par défaut des données et choisir une couleur pour les lignes de vos diagrammes.",
    "images": "Enregistrez des images pour les utiliser dans les systèmes en direct. Vous pouvez choisir une image par défaut ou charger vos propres images.",
    "downloads": "Téléchargez les données enregistrées de votre système pendant une période donnée. Vous pouvez enregistrer vos téléchargements pour un usage ultérieur ou effectuer un téléchargement rapide pour un usage immédiat.",
    "liveSchemes": "Affichez vos données en direct sur une image de système. Vous pouvez placer les données sur le schéma en les faisant glisser à l’endroit voulu sur l’image de système. L’enregistrement s’effectue automatiquement dès que vous aurez placé les données.",
    "diagrams": "Affichez vos données sous forme de diagramme pour une période choisie. Choisissez pour cela un filtre prédéfini (voir ci-dessus).",
    "question": "Comment ça marche ?",
    "friends": "Invitez d'autres utilisateurs VBus.net pour leur permettre d'accéder à votre système. Ils peuvent ainsi créer des diagrammes, des systèmes en direct, etc. ",
    "monitoringGeneral": "La surveillance VBus.net vous permet d'accéder au protocole d'erreurs indiquant automatiquement les erreurs qui se sont produites. Vous avez également accès aux notifications qui vous permettent de surveiller n'importe quel paramètre de votre système et qui vous informent par e-mail.",
    "monitoringNotification": "Les notifications vous permettent de surveiller différents paramètres de votre système. Vous pouvez définir des seuils et camparer ceux-ci avec les données en direct de votre système en utilisant différentes catégories. Si les conditions nécessaires à la notification sont satisfaites, vous  serez informé par e-mail. En cas d'interruption de la connexion, vous recevrez automatiquement un e-mail. Vous serez également informé une fois la connexion rétablie.",
    "monitoringErrorlog": "Le protocole d'erreurs vous offre une vue d'ensemble des erreurs du système et indique également la date et l'heure de celles-ci. Le protocole vous indique le module et les sondes correspondantes (selon le régulateur) ce qui facilite la détection de pannes.",
    "reports": "Recevez les données enregistrées de votre système régulièrement et automatiquement par e-mail. Vous pouvez définir une période de temps et limiter les données à l'aide d'un filtre prédéfini (voir ci-dessus). Il est également possible d'ajouter plusieurs destinataires.",
    "backup": "Créez une sauvegarde de tous vos réglages de visualisation.",
    "extendedReports": "Recevez régulièrement des informations sur l'état de votre système par e-mail. Recevez par exemple une fois par semaine des informations sur le rendement (sous forme de diagramme), des messages d'erreur, etc.",
    "conversionsAndArithmeticOperations": "Conversions et opérations de calcul de données",
    "parametrization": "Paramétrez très simplement votre régulateur à travers votre navigateur Internet. Sauvegardez les configurations directement dans VBus.net et transférez-les sur votre régulateur, si nécessaire. "
  },
  "links": {
    "didNotReceiveConfirmationInstructions": "Vous n'avez pas reçu de confirmation de votre inscription ?",
    "didNotReceiveUnlockInstructions": "Vous n'avez pas reçu d'instructions pour débloquer votre compte?"
  },
  "customer": {
    "examples": "Exemples de nos clients"
  },
  "dashboard": {
    "proSubscriptionSchemeEditor": "Editeur de système avancé",
    "testProSubscription": "Testez gratuitement VBus.net PRO pendant 30 jours !",
    "proSubscriptionLiveData": "Mise à jour des données toutes les minutes",
    "proSubscriptionWeatherDashboard": "Affichage des informations météorologiques sur le tableau de bord",
    "proSubscriptionErrorLog": "Protocole d'erreurs",
    "proSubscriptionReporting": "Notifications par e-mail configurables librement",
    "proSubscriptionFriendship": "Partager les droits d'accès, par exemple, avec l'installateur pour lui donner des informations sur le système",
    "proSubscriptionEnable": "Oui, je souhaite tester l'accès PRO",
    "proSubscriptionDoNotRemember": "Ne plus rappeler",
    "textClaimDemoQuestion": "Vous n'avez pas encore de Datalogger ou de module de communication ?",
    "textClaimDemo1": "Vous souhaitez quand même vous informer sur les possibilités de VBus.net ?",
    "textClaimDemo2": "Veuillez ajouter un Datalogger de démonstration à votre compte pour le tester.",
    "claimDemo": "Ajouter Datalogger de démonstration maintenant",
    "textClaimOwnQuestion": "Vous avez déjà un Datalogger ou un module de communication ?",
    "textClaimOwn1": "Veuillez ajouter votre appareil à votre compte.",
    "claimOwn": "Ajouter mon apparail maintenant",
    "noDiagramAvailable": "Vous devez créer au moins un diagramme pour afficher celui-ci sur le tableau de bord.",
    "noLiveSystemAvailable": "Vous devez créer au moins un système en direct pour afficher celui-ci sur le tableau de bord.",
    "noWeatherAvailable": "Vous devez définir d'abord un emplacement pour l'appareil pour afficher celui-ci.",
    "demoVisualisierung": "Visualisation de démonstration",
    "ownVisualisierung": "Visualiser son propre appareil",
    "chooseComponent": "Veuillez sélectionner un composant du tableau de bord",
    "addComponent": "Ajouter nouveau composant",
    "editComponent": "Modifier composant",
    "changeBackgroundColor": "Modifier couleur d'arrière-plan",
    "deleteAllComponents": "Supprimer tous les composants",
    "addComponentInfo": "Ajoutez de nouveaux composants à votre tableau de bord",
    "notAvailableInFullscreen": "Pas disponible en mode plein écran !",
    "reloadComponent": "Recharger composant",
    "deleteSelectedComponents": "Effacer composants sélectionnés",
    "deselectAll": "Désélectionner tous",
    "noImageAvailable": "Vous devez d'abord créer au moins une image pour que celle-ci s'affiche dans le tableau de bord.",
    "notAllowedForSubscription": "Ce contenu n'est pas ou n'est plus disponible pour votre accès.",
    "removeThisComponent": "Voulez-vous enlever ce composant du tableau de bord ?",
    "removeSelectedComponents": "Voulez-vous enlever les composants sélectionnés du tableau de bord ?",
    "load": "",
    "loadFromOtherDevice": "",
    "loadFromOtherDeviceInfo": "",
    "settings": "",
    "itemBorderTyp": "",
    "itemBorderNone": "",
    "itemBorder": "",
    "itemBorderShadow": "",
    "lockItems": "",
    "deleteQuestion": "",
    "delete": ""
  },
  "images": {
    "clickOnImageText": "Cliquez sur l'image de votre choix.",
    "currentImage": "Image actuelle"
  },
  "enter": {
    "name": {
      "diagram": "Veuillez saisir le nom du diagramme",
      "filter": "Veuillez saisir le nom du filtre",
      "scheme": "Veuillez saisir le nom du système",
      "image": "Veuillez saisir le nom de l'image"
    },
    "vbus": {
      "password": "Veuillez saisir le mot de passe VBus et cliquer sur CONTINUER."
    }
  },
  "prepare": {
    "download": "Les données sont en cours de préparation. Cette opération peut durer quelques instants. Veuillez patienter..."
  },
  "access": {
    "denied": "Accès refusé"
  },
  "data": {
    "filter": "Filtres",
    "transmission": {
      "running": "Transfert de données en cours…"
    }
  },
  "genral": {
    "to": "Jusqu'à"
  },
  "unselect": {
    "all": "Désélectionner tout"
  },
  "my": {
    "account": "Mon compte",
    "diagrams": "Mes diagrammes",
    "downloads": "Mes téléchargements",
    "schemes": "Mes affichages de données en direct",
    "devices": "Mes appareils",
    "friends": "Utilisateurs VBus.net ayant accès à mes appareils",
    "reports": "Mes rapports"
  },
  "limitationText": {
    "noConfiguration": "Ne permet pas de configurer le Datalogger",
    "only90days": "Seules les données enregistrées pendant les derniers 90 jours sont disponibles",
    "onlyDemoDatalogger": "Permet d'accéder uniquement au Datalogger de démonstration"
  },
  "info": {
    "smallerLogInterval": "VBus.net ne supporte pas les intervalles d'enregistrement courts définis dans le Datalogger.",
    "logInterval": "VBus.net mémorise les données enregistrées par votre Datalogger RESOL à au moins 5 minutes d'intervalle.",
    "clickToDelete": "Supprimer : <i class=\"fa fa-trash-o clickToDelete\"></i> ",
    "clickToEdit": "Modifier : <i class=\"fa fa-edit clickToEdit\"></i> ",
    "clickToMove": "Déplacer : <i class=\"fa fa-arrows-v clickToMove\"></i>"
  },
  "modal": {
    "info": {
      "filter": "Si vous souhaitez afficher uniquement certaines données de votre système, vous pouvez créer un <a class='link' href='/vbus/add-selector'>filtre</a> personnalisé. Celui-ci apparaîtra sur la liste et vous pourrez le sélectionner pour l'affichage."
    }
  },
  "discover": {
    "deviceDiscovery": "Device Discovery",
    "deviceDiscoveryWizard": "Device Discovery Wizard"
  },
  "unlocks": {
    "resendUnlockInstructions": "Me renvoyer les instructions pour débloquer mon compte"
  },
  "activerecord": {
    "errors": {
      "models": {
        "ownership": {
          "attributes": {
            "name": {
              "too_short": "est trop court (minimum requis : 3 caractères)"
            }
          }
        }
      }
    }
  },
  "forward": {
    "toWebinterfaceOfDatalogger": "Redirection vers l'interface web du Datalogger en cours…",
    "notAllowedToAccessOwnership": "Vous n'avez pas d'accès à cet appareil.",
    "textForwardedToWebInterface": "Si cet appareil était le vôtre, vous seriez automatiquement redirigé vers l'interface web de ce dernier en quelques secondes. Le Datalogger de démonstration ne permet pas cette opération. Merci de votre compréhension.",
    "textLoginOtherCredentials": "N'oubliez pas que les données d'accès à l'interface web de l'appareil sont différentes des données d'accès au compte VBus.net.",
    "textYouWillBeForwarded": "Vous êtes sur le point d'être redirigé vers l'interface web de votre appareil. Si cela n'est pas le cas, cliquez sur le lien suivant.",
    "datenloggerLink": "Interface de l'appareil"
  },
  "paypal": {
    "buy": {
      "now": "Acheter"
    },
    "order": {
      "text": "Cette opération est susceptible de durer quelques jours.",
      "error": "Une erreur s'est produite lors du tranfert de données avec Paypal. Veuillez contacter notre assistance technique si les fonctions que vous avez achetées ne sont pas disponibles."
    }
  },
  "invalid": {
    "via_tag": "L'identificateur Via doit avoir au moins 3 caractères et doit commencer par une minuscule. Caractères autorisés : minuscules, chiffres, traits d'union et tirets bas."
  },
  "incorrect": {
    "failure": {
      "already_activated": "Vous ne pouvez pas utiliser cet identificateur Via. Veuillez en choisir un autre."
    }
  },
  "selected": {
    "dataFields": "Champs de données sélectionnés"
  },
  "legend": {
    "description": "Légende",
    "layout": {
      "align": "Position",
      "horizontal": "Horizontale",
      "vertical": "Verticale"
    },
    "position": {
      "horizontal": "Position horizontale",
      "vertical": "Position verticale",
      "left": "Gauche",
      "central": "Milieu",
      "right": "Droite",
      "top": "En haut",
      "bottom": "En bas"
    }
  },
  "datapoint": {
    "selectedOne": "Donnée sélectionée",
    "selectedMore": "Données sélectionnées"
  },
  "information": {
    "minOneOwnership": "Si vous souhaitez utiliser les fonctions d'affichage, vous devez ajouter un appareil ou un Datalogger de démonstration à votre compte."
  },
  "tip": {
    "location": "Si vous indiquez l'emplacement de votre appareil, vous pourrez obtenir des informations météorologiques. Saisissez les coordonnées géographiques de votre système ou cherchez l'emplacement."
  },
  "messages": {
    "tryGeodata": "Veuillez saisir vos coordonnées géographiques"
  },
  "get": {
    "professional": {
      "account": "Profitez dès maintenant de l'accès PRO"
    }
  },
  "one": {
    "year": {
      "vbus": {
        "professional": "1 an VBus.net PRO"
      }
    }
  },
  "register": {
    "subscribe": {
      "newsletter": "Je souhaite recevoir la newsletter de RESOL"
    },
    "free": "Créer un compte gratuitement"
  },
  "homepage": {
    "greetingText": "Le portail Internet pour un accès simple et sécurisé aux données de votre système",
    "simpleText": "Accès simple en deux étapes :",
    "registerText": "<a href=\"#register\">Créer un compte</a> VBus.net gratuitement ",
    "addDataloggerText": "Ajoutez votre appareil à VBus.net",
    "initationText": "VBus.net est l'outil idéal pour traiter et contrôler les donnés de votre régulateur RESOL. Il vous permet de voir vos donnés en direct, de configurer des filtres personnalisés etc.",
    "dataViewerHeader": "Intégré dans VBus.net - le VBus Data Viewer",
    "dataViewerInfo": "Affichez les données enregistrées sur la carte mémoire SD à l'aide du VBus Data Viewer"
  },
  "errorLog": {
    "thankYou": "Merci d'envoyer votre rapport d'erreurs",
    "ticketNumberText": "Votre ticket a le numéro suivant :"
  },
  "rerrorReport": {
    "helpText": "Aidez-nous à améliorer le fonctionnement de VBus.net en nous signalant les dysfonctionnements éventuellement constatés lors de son utilisation."
  },
  "friendshipToken": {
    "typeOfUse": "Usage",
    "useText": "Veuillez saisir un nom afin de pouvoir identifier le code d'accès (token) après coup. Cela vous permet d'avoir une vue d'ensemble des personnes ayant accès a votre appareil."
  },
  "cookies": {
    "name": "Cookies",
    "useVBusnet": "Vous devez accepter l'utilisation de cookies pour pouvoir utiliser VBus.net.",
    "description1": "Les cookies sont de petits fichiers de texte envoyés par un site web et sauvegardés sur votre ordinateur. Ils contiennent des informations sur votre visite des sites Internet, p. ex. votre langue préférée et d'autres paramètres.",
    "description2": "VBus.net utilise des cookies pour enregistrer votre langue et les informations sur votre compte.",
    "furtherInformation": "Pour plus d'informations sur les cookies et leur gestion, voir",
    "disclaimerExternalLinks": "Veuillez noter que nous ne sommes pas responsables du contenu des sites web externes.",
    "privacyPolicy": "Pour plus d'informations sur les cookies et leur gestion, veuillez consulter notre"
  },
  "subscribe": {
    "maintenance": "Oui, je souhaite être informé par e-mail en cas de travaux de maintenance."
  },
  "title": {
    "help": "Aide"
  },
  "original": {
    "names": "Nom par défaut",
    "value": "Valeur d'origine"
  },
  "cookie": {
    "acceptText": "Réglementation sur les cookies"
  },
  "viaTag": {
    "useDefaultPassword": "Votre appareil est accessible avec votre mot de passe standard !",
    "ChangePasswordText": "Pour des raisons de sécurité, veuillez modifier le mot de passe de votre appareil."
  },
  "lineChart": {
    "diagram": "Courbe (absolu)"
  },
  "barChart": {
    "diagram": "Histogramme (résumé du jour)"
  },
  "werbung": {
    "textDatenlogger": "Plus d'informations sur notre Datalogger / nos modules ?",
    "textKommunikationsmodul": "Avez-vous déjà découvert notre module de communication ?",
    "textSolarregler": "Connaissez-vous déjà nos régulateurs solaires et de système ?",
    "textHeizungsregler": "Voulez-vous vous informer sur notre famille de régulateurs de chauffage ?"
  },
  "notice": {
    "dataloggerTimeout": "Cet appareil ne fournit plus de données en direct depuis plusieurs minutes…",
    "dataloggerInitialze": "Initialisation",
    "dataloggerInitialzeText": "Cela peut prendre quelques minutes jusqu'à ce que votre appareil soit initialisé.",
    "dataloggerInitialzed": "Votre appareil a été initialisé. Vous pouvez maintenant lancer la visualisation."
  },
  "nextStep": {
    "step2": "Si vous souhaitez créer un <b>système en direct</b>, vous avez besoin d'une __IMAGE__.",
    "step3": "Vous pouvez maintenant créer un __DIAGRAM__ ou un __LIVESYSTEM__.",
    "step4": "Effectuez un __DOWNLOAD__  de vos données afin de les traiter ou de les analyser manuellement.",
    "step1": "Veuillez créer d'abord un  __FILTER__ afin de pouvoir créer un <b>diagramme</b> ou un <b>système en direct</b>."
  },
  "support": {
    "noDatafromDevice": "Votre appareil n’a pas fourni de données !",
    "pleaseCheck": "Veuillez consulter le manuel de l’appareil et vérifier les points suivants :",
    "checkPowerSupply": "Alimentation électrique du routeur et du Datalogger / module de communication",
    "checkInternetConnection": "Connexion Internet",
    "checkConncectionToDevice": "Connexion du routeur au Datalogger / module de communication",
    "checkManual": "Pour plus d'informations, veuillez consulter le manuel de votre appareil.",
    "hintIntranet": "Pour les réseaux d’entreprise : les ports 1194 et 1195 sont bloqués par votre pare-feu. Veuillez consulter votre administrateur réseau.",
    "allowAccessToAccount": "",
    "token": "",
    "needHelp": "",
    "tokenRemove": "",
    "tokenCreate": "",
    "extended": ""
  },
  "areaChart": {
    "diagram": "Diagramme en aires"
  },
  "userFeedback": {
    "helpUs": "",
    "takeTheSurvey": "",
    "question1": "",
    "question2": "",
    "question3": "",
    "question4": "",
    "question5": "",
    "question6": "",
    "question7": "",
    "question8": "",
    "question9": "",
    "question10": "",
    "question11": "",
    "question12": "",
    "question13": "",
    "submit": "",
    "simple": "",
    "complicated": "",
    "veryHelpful": "",
    "redundant": "",
    "notUsed": "",
    "excellent": "",
    "insufficient": "",
    "veryEasy": "",
    "extremelyComplex": "",
    "veryGood": "",
    "veryBad": "",
    "indispensable": "",
    "useless": "",
    "dontKnowYet": "",
    "price": "",
    "noAdditionalValue": "",
    "other": "",
    "daily": "",
    "weekly": "",
    "monthly": "",
    "lessThanMonth": "",
    "quietSure": "",
    "certainlyNot": "",
    "backToDashboard": "Retour au tableau de bord",
    "answerAllQuestions": "Veuillez répondre à toutes les questions marquées par <i class=\"fa fa-times\" aria-hidden=\"true\"></i> ! ",
    "extendedPro": "Votre accès VBus.net PRO a été prolongé de 30 jours."
  },
  "dashboardMessage": {
    "changeViaTag": "Pour des raisons techniques, l'extension de l'identificateur Via <kbd>.via.vbus.net</kbd> a été modifiée comme suit: <kbd>vbus.io</kbd>. Veuillez modifier vos marques-pages, le cas échéant.<br><br>(Exemple: mydl2.via.vbus.net -> mydl2.vbus.io). D'autres réglages ne sont pas requis."
  },
  "config": {
    "startWithout": "Lancer sans configuration",
    "empty": "vide",
    "notLoadable": "non téléchargeable"
  },
  "check": {
    "completed": "Verification terminée…"
  },
  "waiting": {
    "running": {
      "tasks": "Achèvement des tâches courantes en cours..."
    }
  },
  "dsgvo": {
    "Nutzungsbedingungen": "J'ai lu et compris les <a href=\"#register\" class=\"open-terms-of-use\">conditions d'utilisation</a> et je les accepte.",
    "Datenschutzerklaerung": "J'ai lu et compris la <a href=\"#register\" class=\"open-privacy-policy\">déclaration de confidentialité</a> et je l'accepte."
  },
  "pro": {
    "validUntil": "Accès PRO valable jusqu'à"
  },
  "channel": {
    "no": "Numéro du canal"
  },
  "location": {
    "notFound": "Aucun emplacement trouvé !"
  },
  "faq": {
    "q1": "Comment ajouter un appareil à VBus.net ?",
    "a1": "Connectez-vous à VBus.net. Ouvrez le menu Mes appareils et cliquez sur Ajouter un appareil. Saisissez le code d'accès (token) de votre appareil.",
    "q2": "Comment créer un rapport de support ?",
    "a2_1": "Connectez-vous à l'interface Web du KM2, cliquez sur Etat -> Support-Report puis sur Télécharger.",
    "a2_2": "Enregistrez le fichier et envoyez-le à __EMAIL__.",
    "a2_3": "Saisissez l'adresse IP du Datalogger dans le navigateur et connectez-vous sur l'interface Web.",
    "a2_4": "Saisissez l'URL  http://[IP DE  L'APPAREIL]/dlx/support",
    "a2_5": "Le lien \"Cliquez ici pour générer et télécharger le rapport d’aide\" s'affiche et vous permet d'effectuer le téléchargement.",
    "q3": "Mon appareil n'est pas en ligne, que faire ?",
    "a3": "Veuillez vérifier si l'appareil est connecté à Internet. Si d'autres appareils sur le même réseau ne sont pas connectés à Internet, il y a peut-être un problème avec la connexion Internet. Pour accéder à VBus.net, l'appareil doit avoir un accès illimité aux ports 80 et 1194 / 1195. L'accès aux ports ne doit pas être bloqué par un pare-feu.",
    "q4": "L'utilisation de VBus.net est-elle payante ?",
    "a4": "La version de base de VBus.net est gratuite et vous permet d'afficher votre système et de recevoir des données en direct toutes les 5 minutes. La version PRO coûte 39 € par an et offre, en plus des fonctions de base, de nombreuses possibilités de surveillance et des fonctions d'affichage avancées. De plus, le paramétrage à travers WebRPT est possible et les données en direct sont mises à jour chaque minute.",
    "q5": "Quelle est la différence entre VBus.net Basic et PRO ?",
    "a5": "Ici, vous trouverez une comparaison des différentes versions VBus.net : __VERSIONSVERGLEICH__",
    "q6": "Est-ce que l'adaptateur interface VBus®/LAN est compatible avec VBus.net ?",
    "a6": "Non, pour connecter votre régulateur à VBus.net, un module de communication KM2, Datalogger DL2 ou DL3 est requis.",
    "q7": "Mes diagrammes ne sont pas affichés correctement, que faire ?",
    "a7": "Veuillez vérifier si le fuseau horaire dans Mes appareils est réglé correctement et correspond à la localisation de l'appareil. Vérifiez également le fuseau horaire réglé dans l'appareil.",
    "q8": "Quel est le mot de passe pour le paramétrage ?",
    "a8": "vbus",
    "title": "Réponses aux questions les plus fréquemment posées",
    "hints": "Veillez à utiliser une version actuelle du navigateur. Si des problèmes persistent, utlisez un autre navigateur.",
    "notFound": "Aucune réponse à votre question? Veuillez nous contacter sous __LINK__.",
    "q9": "Il y a des désignations non utilisées sur l'axe Y.",
    "a9": "Le filtre utilisé dans ce diagramme doit être enregistré à nouveau.",
    "q10": "Toutes les  valeurs ne sont pas affichées dans mon système en direct, diagramme ou téléchargement.",
    "a10": "Vérifiez le filtre correspondant et sauvegardez-le à nouveau, le cas échéant.",
    "q11": "Pourquoi est-ce que VBus.net ne fonctionne pas sur mon ancien appareil Android v2.x ou ancienne télévision intelligente ?",
    "a11": "VBus.net a adapté ses réglages de sécurité au standard actuel. C'est la raison pour laquelle des appareils plus anciens ne sont plus compatibles avec VBus.net. Pour utiliser VBus.net, veuillez vérifier auprès du fabricant de votre appareil s'il y a un nouveau logiciel pour votre appareil."
  },
  "createImageFirst": "Vous devez d'abord créer une image…",
  "professinal": {
    "expiredOn": "Accès Pro a expriré le __VALID_UNTIL__ !",
    "expireInfo": ""
  },
  "validation": {
    "positiveNumber": "nombre positif"
  },
  "reset": {
    "allEntries": "Réinitialiser toutes les entrées"
  },
  "fileSizeToBig": "Le fichier est trop grand !",
  "controllerVersionChanged": "La version de votre régulateur a changé !",
  "cantLoadConfigurations": "Quelques configurations ne peuvent pas être chargées, parce qu'elles ne sont plus compatibles avec cette version.",
  "dl3NotSupported": "DL3 n'est actuellement pas compatible !",
  "change": {
    "modulename": ""
  },
  "email": {
    "doNotReply": ""
  },
  "discoveryTool": {
    "title": "",
    "text": ""
  },
  "group": {
    "create": "",
    "edit": "",
    "delete": "",
    "deleteGroup": "",
    "neDeviceDelete": ""
  },
  "filterValue": {
    "add": "",
    "sub": "",
    "mul": "",
    "div": "",
    "conversionWithFilter": "",
    "linkedTo": ""
  },
  "errorSendingEmails": "",
  "errorSendingEmailConfirm": "",
  "confirmEmailServices": "",
  "keyboard": {
    "capsLockActive": ""
  },
  "firmware": {
    "title": "",
    "available": "",
    "downloadText": "",
    "deviceInstall": "",
    "acceptText": "",
    "alreadyAccepted": "",
    "activateAutomaticUpdate": ""
  }
}



// WEBPACK FOOTER //
// ./src/locales/mtf/fr/index.js